var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-10",
    cx: 252.29,
    cy: 357.49,
    rx: 233.93,
    ry: 135.06,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "474.19 222.74 471.52 224.33 416.76 192.71 419.43 191.12 474.19 222.74",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.43 191.12 471.52 221.19 471.52 97.64 419.43 67.59 419.43 191.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,195.62l64.83,37.43V94.73L411.73,57.3Zm5-129.59,54.76,31.61V224.33l-54.76-31.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.76 192.71 419.43 191.12 419.43 67.59 416.76 66.03 416.76 192.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.73 57.3 414.44 55.75 479.27 93.18 476.56 94.73 411.73 57.3",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.27 93.18 476.56 94.73 476.56 233.05 479.27 231.5 479.27 93.18",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.34 188 467.61 213.57 467.61 102.35 423.34 76.79 423.34 188",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.34 188 467.61 213.57 467.61 102.35 423.34 76.79 423.34 188",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.61,169.38a41.81,41.81,0,0,1-6.33,0,80.09,80.09,0,0,1-21.56-4.69c-5.36-2-10.71-4.55-16.38-4.7V188l6,3.47a20.2,20.2,0,0,1,8.22-4.57c8.53-2.24,17.28,2,26.05,3a35.78,35.78,0,0,0,4,.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.61,145.4c-9.9-2.93-20.07-5.36-27.14-12.63-5.69-5.86-8.38-14-10.25-21.93s-3.16-16.17-6.77-23.5c0-.08-.08-.14-.11-.22v46c.55.83,1.11,1.66,1.7,2.46,6.5,8.82,16.09,16.18,27,16.75,5.14.26,10.45-.94,15.54-.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.61,126.65C460,120,456,109.2,457.8,99.18c.14-.74.31-1.47.5-2.21l-17-9.83q.11,1.68.15,3.36c.18,6.5,0,13.09,1.4,19.43A38.17,38.17,0,0,0,462.22,135a36.74,36.74,0,0,0,5.39,2.25Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.83 102.92 392.54 104.28 345.65 77.21 347.93 75.84 394.83 102.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.93 75.84 392.54 101.59 392.54 63.66 347.93 37.93 347.93 75.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.34,79.7l55.51,32.05V61.17l-55.51-32Zm4.31-43.11,46.89,27.07v40.62L345.65,77.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.65 77.21 347.93 75.84 347.93 37.93 345.65 36.59 345.65 77.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.34 29.12 343.66 27.79 399.17 59.84 396.85 61.17 341.34 29.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.17 59.84 396.85 61.17 396.85 111.75 399.17 110.42 399.17 59.84",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.68 74.45 390.8 98.19 390.8 95.1 380.52 71.36 374.11 77.29 375 82.8 362.22 56.88 349.68 71.36 349.68 74.45",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,59.89a6.72,6.72,0,0,1,3,5.27c0,1.94-1.36,2.73-3,1.76a6.72,6.72,0,0,1-3-5.27C371.46,59.71,372.82,58.92,374.5,59.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.83 174.18 392.54 175.55 345.65 148.47 347.93 147.11 394.83 174.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.93 147.11 392.54 172.86 392.54 134.93 347.93 109.19 347.93 147.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.34,151l55.51,32V132.44l-55.51-32Zm4.31-43.11,46.89,27.08v40.62l-46.89-27.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.65 148.47 347.93 147.11 347.93 109.19 345.65 107.86 345.65 148.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.34 100.39 343.66 99.06 399.17 131.11 396.85 132.44 341.34 100.39",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.17 131.11 396.85 132.44 396.85 183.01 399.17 181.69 399.17 131.11",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.68 145.71 390.8 169.46 390.8 166.37 380.52 142.62 374.11 148.56 375 154.06 362.22 128.14 349.68 142.62 349.68 145.71",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,131.16a6.72,6.72,0,0,1,3,5.27c0,1.94-1.36,2.72-3,1.75a6.71,6.71,0,0,1-3-5.26C371.46,131,372.82,130.19,374.5,131.16Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.96 41.64 150.77 43.21 150.77 166.55 147.96 164.98 147.96 41.64",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.96 164.98 147.95 44.83 35.17 109.95 35.19 230.09 147.96 164.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,169.56V34.18L30,106.94V242.32ZM35.17,233.29V110l115.6-66.74V166.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.77 166.55 147.96 164.98 35.19 230.09 35.17 233.29 150.77 166.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.28 61.39 122.09 59.76 122.09 183.1 119.28 181.54 119.28 61.39",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.93 97.97 58.74 96.34 58.74 219.68 55.93 218.12 55.93 97.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.95 242.32 27.16 240.7 27.16 105.31 29.95 106.94 29.95 242.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.16 105.31 29.95 106.94 155.98 34.18 153.19 32.55 27.16 105.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.17 166.18 35.17 169.42 150.78 102.67 147.98 101.04 35.17 166.18",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "35.18 175.43 35.17 169.42 150.78 102.67 150.77 108.7 35.18 175.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.74 225.71 63.95 222.7 63.95 87.31 58.74 90.32 58.74 225.71",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.08 189.13 127.29 186.13 127.29 50.74 122.08 53.75 122.08 189.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.74 155.81 55.93 154.19 55.93 97.97 58.74 96.34 58.74 155.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.07 119.25 119.26 117.63 119.26 61.4 122.07 59.78 122.07 119.25",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-10",
    d: "M78.51,453.88a11.94,11.94,0,0,1-1.91,4.43,21,21,0,0,1-7.16,6.36c-12.39,7.15-32.48,7.15-44.87,0a21.11,21.11,0,0,1-7.16-6.36,12.05,12.05,0,0,1-1.89-4.43h0c-1.11-5.38,1.92-11,9.06-15.11,12.39-7.16,32.48-7.16,44.87,0C76.58,442.9,79.61,448.5,78.51,453.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10",
    d: "M469.73,436.9a25.59,25.59,0,0,1-4.05,9.42c-3.26,4.92-8.34,9.53-15.2,13.5-26.3,15.18-69,15.18-95.25,0-6.85-4-11.93-8.58-15.2-13.5a25.68,25.68,0,0,1-4-9.42h0c-2.35-11.41,4.08-23.31,19.24-32.06,26.3-15.2,68.95-15.2,95.25,0C465.64,413.59,472.07,425.49,469.73,436.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10",
    d: "M101,444.28,14.1,394.61c-1.27-.73-1.27-1.91,0-2.64L290.85,232.19a5.06,5.06,0,0,1,4.58,0l86.91,49.67a1.4,1.4,0,0,1,0,2.65L105.59,444.28A5.06,5.06,0,0,1,101,444.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10",
    d: "M355.93,383.31l-11.83-6.83a9.08,9.08,0,0,0-8.66.21l-61.08,39.39c-11.92-7-28.39-11.26-46.58-11.26-36.38,0-65.88,17.22-65.88,38.46s29.5,38.47,65.88,38.47,65.89-17.22,65.89-38.47c0-6.79-3-13.16-8.32-18.7l70.47-36.41C358.31,386.89,358.36,384.71,355.93,383.31Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.91,417.2h0a3.46,3.46,0,0,1-3.47-.34,10.8,10.8,0,0,1-4.92-8.48A3.42,3.42,0,0,1,278,405.2h0L339,366.59h0c1.25-.84,3-.79,5,.35a15.15,15.15,0,0,1,6.89,11.86c0,2.3-.84,3.87-2.19,4.54h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,408.38c0-3.13,2.18-4.41,4.9-2.85a10.86,10.86,0,0,1,4.92,8.49c0,3.13-2.19,4.4-4.9,2.84A10.8,10.8,0,0,1,276.52,408.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,421.68a6.54,6.54,0,0,1-3-5.13,2,2,0,0,1,.86-1.92h0l12.13-7.06h0a2.09,2.09,0,0,1,2.1.2,6.57,6.57,0,0,1,3,5.13,2.09,2.09,0,0,1-.87,1.93l-12.13,7.05h0A2.07,2.07,0,0,1,269.3,421.68Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,421.68a6.54,6.54,0,0,1-3-5.13,2,2,0,0,1,.86-1.92h0l12.13-7.06h0a2.09,2.09,0,0,1,2.1.2,6.57,6.57,0,0,1,3,5.13,2.09,2.09,0,0,1-.87,1.93l-12.13,7.05h0A2.07,2.07,0,0,1,269.3,421.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,411.91q-.66-.51-1.38-1l-6.39,3.71a36.72,36.72,0,0,1,7.11,5.58l5.86-3.4-.48-.56A38.24,38.24,0,0,0,275,411.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,407.53l62.81-38.59a11.74,11.74,0,0,0-2.51-2c-2-1.14-3.77-1.19-5-.34h0l-61,38.6a3.44,3.44,0,0,1,3.47.34A9.14,9.14,0,0,1,283.72,407.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,432.61c0-.25,0-.45,0-.59s0-.47,0-.71c0-.58-.09-1.15-.17-1.72,0-.21-.07-.41-.11-.63a19.65,19.65,0,0,0-.58-2.35l-.21-.64c-.21-.57-.43-1.15-.68-1.71-.09-.2-.18-.39-.28-.59l-.27-.54c-.13-.25-.26-.5-.41-.75s-.28-.5-.44-.75l-.47-.73a26,26,0,0,0-2.84-3.61,34.33,34.33,0,0,0-4.48-4.09,48.43,48.43,0,0,0-5.64-3.75c-22-12.58-57.58-12.58-79.36,0-.55.32-1.08.64-1.6,1a43.7,43.7,0,0,0-5.53,4.06c-.49.44-1,.88-1.43,1.33a31.42,31.42,0,0,0-3.16,3.58c-.17.22-.33.45-.49.68s-.42.61-.61.92-.53.85-.77,1.28-.51,1-.74,1.44c-.1.21-.2.41-.28.62s-.25.58-.36.88-.17.44-.24.66a19.84,19.84,0,0,0-1,4.69c0,.17,0,.34,0,.51,0,.37,0,.74,0,1.09,0,1.37,0,7.54,0,8.68,0,8.32,5.48,16.67,16.52,23,21.91,12.65,57.45,12.65,79.36,0,11.07-6.38,16.52-14.76,16.37-23.11C283,439.81,283.06,434.63,283,432.61Zm-92.83-17.69c9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6c8.65,4.93,13.41,11.11,13.43,17.4s-4.68,12.41-13.22,17.34c-9.65,5.58-22.62,8.64-36.53,8.64s-26.86-3.06-36.52-8.64c-8.61-5-13.36-11.19-13.36-17.51S181.77,419.8,190.21,414.92Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,432.61c0-.25,0-.45,0-.59s0-.47,0-.71c0-.58-.09-1.15-.17-1.72,0-.21-.07-.41-.11-.63a19.65,19.65,0,0,0-.58-2.35l-.21-.64c-.21-.57-.43-1.15-.68-1.71-.09-.2-.18-.39-.28-.59l-.27-.54c-.13-.25-.26-.5-.41-.75s-.28-.5-.44-.75l-.47-.73a26,26,0,0,0-2.84-3.61,34.33,34.33,0,0,0-4.48-4.09,48.43,48.43,0,0,0-5.64-3.75c-22-12.58-57.58-12.58-79.36,0-.55.32-1.08.64-1.6,1a43.7,43.7,0,0,0-5.53,4.06c-.49.44-1,.88-1.43,1.33a31.42,31.42,0,0,0-3.16,3.58c-.17.22-.33.45-.49.68s-.42.61-.61.92-.53.85-.77,1.28-.51,1-.74,1.44c-.1.21-.2.41-.28.62s-.25.58-.36.88-.17.44-.24.66a19.84,19.84,0,0,0-1,4.69c0,.17,0,.34,0,.51,0,.37,0,.74,0,1.09,0,1.37,0,7.54,0,8.68,0,8.32,5.48,16.67,16.52,23,21.91,12.65,57.45,12.65,79.36,0,11.07-6.38,16.52-14.76,16.37-23.11C283,439.81,283.06,434.63,283,432.61Zm-92.83-17.69c9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6c8.65,4.93,13.41,11.11,13.43,17.4s-4.68,12.41-13.22,17.34c-9.65,5.58-22.62,8.64-36.53,8.64s-26.86-3.06-36.52-8.64c-8.61-5-13.36-11.19-13.36-17.51S181.77,419.8,190.21,414.92Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,432.61h-6.31c0,6.25-4.68,12.13-13.22,17.06-9.36,5.41-21.85,8.45-35.29,8.63v15.05c13.95-.17,27.81-3.32,38.45-9.47,11.07-6.38,16.52-14.76,16.37-23.11C283,439.81,283.06,434.63,283,432.61Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,432c0-.23,0-.47,0-.71,0-.58-.09-1.15-.17-1.72,0-.21-.07-.41-.11-.63a19.65,19.65,0,0,0-.58-2.35l-.21-.64c-.21-.57-.43-1.15-.68-1.71-.09-.2-.18-.39-.28-.59l-.27-.54c-.13-.25-.26-.5-.41-.75s-.28-.5-.44-.75l-.47-.73a26,26,0,0,0-2.84-3.61,35.74,35.74,0,0,0-4.48-4.09,48.43,48.43,0,0,0-5.64-3.75c-22-12.58-57.58-12.58-79.36,0-.55.32-1.08.64-1.6,1a43.7,43.7,0,0,0-5.53,4.06c-.49.44-1,.88-1.43,1.33a31.42,31.42,0,0,0-3.16,3.58c-.17.22-.33.45-.49.68s-.42.61-.61.92-.53.85-.77,1.28-.51,1-.74,1.44c-.1.21-.2.41-.28.62s-.25.58-.36.88-.17.44-.24.66a19.84,19.84,0,0,0-1,4.69c0,.17,0,.34,0,.51,0,.37,0,.74,0,1.09,0,8.31,5.51,16.63,16.52,23,21.91,12.65,57.45,12.65,79.36,0,10.81-6.24,16.27-14.37,16.37-22.53C283.05,432.36,283,432.16,283,432Zm-19.53,17.65c-9.65,5.58-22.62,8.64-36.53,8.64s-26.86-3.06-36.52-8.64c-8.61-5-13.36-11.19-13.36-17.51s4.67-12.36,13.11-17.24c9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6c8.65,4.93,13.41,11.11,13.43,17.4S272.05,444.74,263.51,449.67Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,432c0-.23,0-.47,0-.71,0-.58-.09-1.15-.17-1.72,0-.21-.07-.41-.11-.63a19.65,19.65,0,0,0-.58-2.35l-.21-.64c-.21-.57-.43-1.15-.68-1.71-.09-.2-.18-.39-.28-.59l-.27-.54c-.13-.25-.26-.5-.41-.75s-.28-.5-.44-.75l-.47-.73a26,26,0,0,0-2.84-3.61,35.74,35.74,0,0,0-4.48-4.09,48.43,48.43,0,0,0-5.64-3.75c-22-12.58-57.58-12.58-79.36,0-.55.32-1.08.64-1.6,1a43.7,43.7,0,0,0-5.53,4.06c-.49.44-1,.88-1.43,1.33a31.42,31.42,0,0,0-3.16,3.58c-.17.22-.33.45-.49.68s-.42.61-.61.92-.53.85-.77,1.28-.51,1-.74,1.44c-.1.21-.2.41-.28.62s-.25.58-.36.88-.17.44-.24.66a19.84,19.84,0,0,0-1,4.69c0,.17,0,.34,0,.51,0,.37,0,.74,0,1.09,0,8.31,5.51,16.63,16.52,23,21.91,12.65,57.45,12.65,79.36,0,10.81-6.24,16.27-14.37,16.37-22.53C283.05,432.36,283,432.16,283,432Zm-19.53,17.65c-9.65,5.58-22.62,8.64-36.53,8.64s-26.86-3.06-36.52-8.64c-8.61-5-13.36-11.19-13.36-17.51s4.67-12.36,13.11-17.24c9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6c8.65,4.93,13.41,11.11,13.43,17.4S272.05,444.74,263.51,449.67Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,432.33a12.77,12.77,0,0,1-.4,3.18c-1.31-5.19-5.82-10.16-13-14.26-9.72-5.55-22.74-8.6-36.66-8.6s-26.83,3.05-36.43,8.59c-7,4-11.42,8.95-12.71,14.07a12.48,12.48,0,0,1-.4-3.15c0-6.24,4.67-12.36,13.11-17.24,9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6C272,419.86,276.71,426,276.73,432.33Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,432.33a12.77,12.77,0,0,1-.4,3.18c-1.31-5.19-5.82-10.16-13-14.26-9.72-5.55-22.74-8.6-36.66-8.6s-26.83,3.05-36.43,8.59c-7,4-11.42,8.95-12.71,14.07a12.48,12.48,0,0,1-.4-3.15c0-6.24,4.67-12.36,13.11-17.24,9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6C272,419.86,276.71,426,276.73,432.33Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,434c-.74,5.67-5.33,11.19-13.12,15.69-9.65,5.58-22.62,8.64-36.53,8.64s-26.86-3.06-36.52-8.64c-7.89-4.56-12.53-10.15-13.26-15.91.73-5.69,5.28-11.19,13-15.65,9.6-5.54,22.54-8.59,36.43-8.59s26.94,3.05,36.66,8.6C271.24,422.64,275.91,428.22,276.63,434Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Case--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.06,243.64l5-2.91s26.71-87.16,29.2-92.21-2-7.63-6.82-4.85L68.67,288.29c-4.81,2.77-6.33,6.59-10.61,14.91s-28.4,88.4-28.4,88.4a4.45,4.45,0,0,0,2.15,4.7l57.1,33.07L351.24,277.92Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,243.64l5-2.91s26.71-87.16,29.2-92.21-2-7.63-6.82-4.85L68.67,288.29c-4.81,2.77-6.33,6.59-10.61,14.91s-28.4,88.4-28.4,88.4a4.45,4.45,0,0,0,2.15,4.7l57.1,33.07L351.24,277.92Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,305.21C58,311.51,32.84,393.3,32.84,393.3L300.26,238.9s26.53-83.13,29.18-88.37-2-7.62-6.82-4.85L71.81,290.3C67,293.08,64.47,298.91,61.21,305.21Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,305.21C58,311.51,32.84,393.3,32.84,393.3L300.26,238.9s26.53-83.13,29.18-88.37-2-7.62-6.82-4.85L71.81,290.3C67,293.08,64.47,298.91,61.21,305.21Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.17 241.85 32.84 393.3 90.93 426.85 353.26 275.4 295.17 241.85",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.17 241.85 32.84 393.3 90.93 426.85 353.26 275.4 295.17 241.85",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,50.84,60.7,196.49c-5.55,3.2-7.28,8.38-6.3,15.21L84.31,421.6c1,6.82,6.41,10.82,12,7.62l250.5-144.57c5.55-3.2,9.25-11.33,8.27-18.15L325.24,57.4C324.26,50.58,319,47.64,313.44,50.84Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,50.84,60.7,196.49c-5.55,3.2-7.28,8.38-6.3,15.21L84.31,421.6c1,6.82,6.41,10.82,12,7.62l250.5-144.57c5.55-3.2,9.25-11.33,8.27-18.15L325.24,57.4C324.26,50.58,319,47.64,313.44,50.84Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.47,55.3a7.8,7.8,0,0,0-6.81.84L73.15,200.72a16.85,16.85,0,0,0-6.4,7.33l-8.08-3.42c1.77-3.88,4.88-5.3,7.53-6.85L316.69,53.21a7.69,7.69,0,0,1,7.08-.73h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.43,431.33v0c-2.48-1-4.33-3.59-4.86-7.34l-29.64-208c-.61-4.26-.81-8.09.74-11.31l8.09,3.43c-.22.45-.41.9-.61,1.37s-.28.75-.39,1.13a.55.55,0,0,0-.05.17,10.28,10.28,0,0,0-.38,1.31,13.43,13.43,0,0,0-.3,1.37,7.48,7.48,0,0,0-.14,1,15.72,15.72,0,0,0,0,4.44L94.68,428c.54,3.79,2.42,6.39,4.93,7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.65,56.15,70.91,201.81c-5.54,3.2-7.27,8.38-6.29,15.2L94.67,428c1,6.82,6.27,9.76,11.81,6.56L357,290c5.54-3.2,9.24-11.33,8.27-18.16L335.46,62.72C334.48,55.89,329.19,53,323.65,56.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.6,289,118,418c-2.87,1.66-5.61.13-6.12-3.4L82.39,207.71c-.51-3.54,1.41-7.75,4.28-9.41l223.6-129c2.87-1.66,5.61-.14,6.12,3.4L345.88,279.6C346.39,283.13,344.47,287.35,341.6,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.39,207.71l29.49,206.93c0,.14.05.27.08.4l223.6-129c2.87-1.66,4.79-5.87,4.28-9.41L310.27,69.27l-223.6,129C83.8,200,81.88,204.17,82.39,207.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.79,335.84a5,5,0,0,1-2.15,4.73c-1.45.83-2.82.07-3.08-1.71a5,5,0,0,1,2.16-4.73C92.16,333.29,93.54,334.06,93.79,335.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,287.39h0a3.87,3.87,0,0,0-1.67,3.67l4.89,34.07c.2,1.39,1.27,2,2.39,1.34h0a3.9,3.9,0,0,0,1.67-3.68l-4.88-34.07C86.21,287.33,85.14,286.74,84,287.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.93,184.7v0l21.55-16.62-4.79-33.38L148.5,169.43l32,17.91Zm129-3.62-9-63-44.07,22.16,9,63ZM204.76,274.42l15-12.84a26.75,26.75,0,0,1,5.71-10L214.3,173.89l-21.54,16.64v0l-11.39,2.62,12,83.61ZM311,112.22l-4.85-33.83-43.64,25.22L267,134.4Zm-73.16,36.52v0l22-11.06-4.31-30-38.31,22.13,4.5,31.44Zm90.53,84.8-6.68-46.69L277.62,209l2.5,17.52ZM109,231.21l22.8-5.27-6.19-43.28L87.23,204.81l5.3,37Zm78.6,46.66-11.94-83.38L138.53,175.2l-6.34,3.66,15.36,107.35ZM113.17,260.4l22.8-5.27-3.36-23.34L109.81,237,93.38,247.64,96.7,271Zm41.22,123.39-5-35-4.29,40.34ZM199.06,358l-6.46-45.1-36.14,35.48L161,380ZM335,279.52l-5.74-40.15-48.26-7-14.73,54.35,4.29,30Zm-225.72,79L116,405.92l23.58-13.6,7.16-61.78-5.53-38.66-22.89,4.68-9.9,5.25a34.56,34.56,0,0,1-6,9.51l6,41.4L124.86,342l.82,5.84Zm8.25-67.74,22.91-4.7L136.79,261,114,266.23,97.55,276.82l.31,2.23c6.46-1.43,11.66,2.06,12.72,9.41a22.06,22.06,0,0,1-.09,6.22Zm74.27,16.24-3.35-23.35-40,8.28,7.24,50.55Zm41.13-35.7c4.56-2.64,7.69-8.69,7-13.51s-5-6.63-9.54-4-7.71,8.68-7,13.52S228.33,274,232.9,271.35Zm29.68,50L258,289l5.89-23.95-11-2.85-9.59,7.87L238,274.84l8,56Zm-25.11,14.5-8.19-57.29c-5.25.59-9.49-2.58-10.36-8.61a16.33,16.33,0,0,1-.15-2.34l-13.25,12.11-11.39,2.68,10.37,72.49Zm10.25-118.36v0l22-11-9-62.92-22,11.07v0L222.59,167l9,62.91Zm5.44,38v0l12.27,3.21,7.43-30.35-2.3-16-22,11.06v0l-16.12,12.46L234,246.64c5.24-.58,9.43,2.62,10.3,8.67a18.85,18.85,0,0,1-.52,7.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,267.93l-3.38-.87L247,273.22l-3.7,3.34L250,323.21l7.22-4.17-4.37-30.52Zm13.46,19.34,3.12,21.8,55.13-31.83L324.71,243l-39.8-5.78ZM247.5,249.54l14,3.69,6.24-25.42-1.2-8.35-14.71,7.39-14.08,10.88.71,5a14.51,14.51,0,0,1,4.64,2A14,14,0,0,1,247.5,249.54Zm37.15-26.67,38,5.51L317.7,194,283,211.47ZM132.55,266.5l-16.2,3.74-9,5.83c.32.16.63.33.94.51a15.12,15.12,0,0,1,7,10.15l6.53-1.26,13-2.72Zm87.53,13.93a13.82,13.82,0,0,1-3.88-4l-7.73,7.09-8.83,2.08,8.81,61.55,23.66-13.66-7.31-51A14.46,14.46,0,0,1,220.08,280.43ZM120.4,300.7l-7.75,4.12c-.22.48-.45.95-.69,1.42a37.88,37.88,0,0,1-4.23,6.49l4.57,31.86,16.43-10.68L131,350,114.6,360.68,120,398.27l14.81-8.55,6.89-59.46-4.72-33Zm63.75-11.61-30.24,6.26,5.28,36.87,27.3-26.8ZM280.81,196l34.68-17.38-7.64-53.39-34.68,17.45ZM201.94,270.5l13.21-11.34a30.17,30.17,0,0,1,1.64-3.81,31,31,0,0,1,3.38-5.21l-9.64-67.31-15.09,11.64-8.57,2L197.6,271.4Zm-75.66-47.83-4.64-32.34-29,16.76,3.81,26.59,9.81-6.38ZM305.63,109.78l-3.39-23.72L267.9,105.88,271,127.21Zm-70.87,35.34,19.72-9.91-2.85-19.93-29,16.75,2.89,20.23Zm-26.62,21-3.4-23.79-47.12,27.21,23.44,13.11,8.09-1.87ZM182.06,274.5,171,196.92l-32-16.61-1.43.83,14.27,99.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,355.71,189,323.2,161.73,350l3.2,22.34Zm38.61-88.44a7.85,7.85,0,0,0,3.78-7.23c-.39-2.61-2.67-3.56-5.13-2.16a7.93,7.93,0,0,0-3.76,7.27C227.57,267.73,229.87,268.7,232.31,267.27Zm12.3-53.43L264.32,204l-7.62-53.27L242,158.07,227.9,169,235.36,221Zm-134.7,43,20.54-5-2.07-14.55-16.2,3.74-13.45,8.73,1.87,13.07Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,355.71,189,323.2,161.73,350l3.2,22.34Zm38.61-88.44a7.85,7.85,0,0,0,3.78-7.23c-.39-2.61-2.67-3.56-5.13-2.16a7.93,7.93,0,0,0-3.76,7.27C227.57,267.73,229.87,268.7,232.31,267.27Zm12.3-53.43L264.32,204l-7.62-53.27L242,158.07,227.9,169,235.36,221Zm-134.7,43,20.54-5-2.07-14.55-16.2,3.74-13.45,8.73,1.87,13.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pins--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.79,200.53c0-5.31-3.5-7.6-7.81-5.11s-7.81,8.81-7.81,14.12v1.21c0,4.09,4.63,8.83,6.76,10.8a1.06,1.06,0,0,0,1.66-.31c1.84-3.77,7.2-15.11,7.2-19.51ZM119,209.22c-2.29,1.33-4.15.25-4.15-2.39a9.17,9.17,0,0,1,4.15-7.18c2.29-1.32,4.14-.25,4.14,2.4A9.14,9.14,0,0,1,119,209.22Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.64,183.92c0-5.31-3.5-7.59-7.81-5.1S184,187.63,184,192.94v1.21c0,4.08,4.63,8.83,6.76,10.79a1,1,0,0,0,1.66-.31c1.84-3.76,7.2-15.1,7.2-19.5Zm-7.81,8.7c-2.29,1.32-4.15.25-4.15-2.39a9.15,9.15,0,0,1,4.15-7.18c2.29-1.32,4.14-.25,4.14,2.39A9.14,9.14,0,0,1,191.83,192.62Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,201.13c0-5.31-3.5-7.6-7.81-5.11s-7.81,8.81-7.81,14.12v1.21c0,4.09,4.63,8.83,6.76,10.8a1.05,1.05,0,0,0,1.66-.31c1.84-3.77,7.2-15.11,7.2-19.51Zm-7.81,8.69c-2.29,1.33-4.14.25-4.14-2.39a9.16,9.16,0,0,1,4.14-7.18c2.29-1.32,4.14-.25,4.14,2.4A9.14,9.14,0,0,1,212.36,209.82Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37,308.12c0-5.31-3.5-7.59-7.81-5.1s-7.81,8.81-7.81,14.12v1.21c0,4.09,4.63,8.83,6.76,10.79a1,1,0,0,0,1.66-.31c1.84-3.76,7.2-15.1,7.2-19.5Zm-7.81,8.7c-2.29,1.32-4.15.25-4.15-2.39a9.17,9.17,0,0,1,4.15-7.18c2.28-1.32,4.14-.25,4.14,2.39A9.17,9.17,0,0,1,137.56,316.82Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,266c0-5.31-3.5-7.59-7.81-5.1s-7.81,8.81-7.81,14.11v1.21c0,4.09,4.63,8.83,6.76,10.8a1.05,1.05,0,0,0,1.66-.31c1.84-3.77,7.2-15.11,7.2-19.5Zm-7.81,8.7c-2.29,1.32-4.14.25-4.14-2.4a9.14,9.14,0,0,1,4.14-7.17c2.29-1.33,4.14-.25,4.14,2.39A9.16,9.16,0,0,1,277.62,274.68Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.66,169.35c0-5.31-3.49-7.59-7.81-5.1s-7.8,8.81-7.8,14.12v1.21c0,4.08,4.63,8.83,6.76,10.79a1,1,0,0,0,1.66-.31c1.84-3.76,7.19-15.1,7.19-19.5Zm-7.81,8.7c-2.29,1.32-4.14.25-4.14-2.39a9.14,9.14,0,0,1,4.14-7.18c2.29-1.32,4.15-.25,4.15,2.39A9.17,9.17,0,0,1,283.85,178.05Z",
    style: {
      fill: "#28A745"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--search-bar--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Search--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.34,15.48c-1.5-.87-3.58-.74-5.88.58L70,123.14c-4.59,2.66-8.32,9.1-8.32,14.4v18.34c0,2.65.93,4.52,2.44,5.39L72.24,166c1.5.87,3.58.74,5.87-.58L263.6,58.3c4.59-2.65,8.31-9.1,8.31-14.4V25.56c0-2.65-.93-4.51-2.42-5.38Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.34,15.48c-1.5-.87-3.58-.74-5.88.58L70,123.14c-4.59,2.66-8.32,9.1-8.32,14.4v18.34c0,2.65.93,4.52,2.44,5.39L72.24,166c1.5.87,3.58.74,5.87-.58L263.6,58.3c4.59-2.65,8.31-9.1,8.31-14.4V25.56c0-2.65-.93-4.51-2.42-5.38Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,137.54v18.34c0,2.65.93,4.52,2.44,5.39L72.24,166c1.44.83,3.42.74,5.6-.44V137.37l-13.74-8A16.94,16.94,0,0,0,61.66,137.54Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,25.56c0-5.3-3.72-7.45-8.31-4.8L78.11,127.84c-4.59,2.65-8.31,9.1-8.31,14.4v18.34c0,5.3,3.72,7.45,8.31,4.8L263.6,58.3c4.59-2.65,8.31-9.1,8.31-14.4Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,25.56c0-5.3-3.72-7.45-8.31-4.8L78.11,127.84c-4.59,2.65-8.31,9.1-8.31,14.4v18.34c0,5.3,3.72,7.45,8.31,4.8L263.6,58.3c4.59-2.65,8.31-9.1,8.31-14.4Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.79,132.29a12.44,12.44,0,0,0-5.6,9.7v15.69c0,2.54,1.79,3.57,4,2.31L238.08,67.6V40.83Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.47,49l-3.33-2.52c-.44-.33-1.06-.13-1.61.43l.06-.12-1.17-.88a16.25,16.25,0,0,0,1.46-6.42c0-5-3-7.25-6.75-5.1s-6.75,7.93-6.75,12.9,3,7.25,6.75,5.1a12.61,12.61,0,0,0,4.17-4.36l1.18.89.06-.12a2,2,0,0,0,.37,1.93l3.33,2.52a1,1,0,0,0,1.11,0A3.05,3.05,0,0,0,265.47,52C266.08,50.81,266.08,49.48,265.47,49Zm-11.34.59c-2.57,1.48-4.66-.1-4.66-3.52s2.09-7.4,4.66-8.88,4.65.09,4.65,3.51S256.69,48.13,254.13,49.61Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.81,131.07a.23.23,0,0,1,.31,0,.53.53,0,0,1,.14.41v16.56a1.32,1.32,0,0,1-.14.56.79.79,0,0,1-.31.39l-1.35.78a.24.24,0,0,1-.32,0,.57.57,0,0,1-.13-.41V142.6l-5,2.9v6.77a1.3,1.3,0,0,1-.13.56.81.81,0,0,1-.32.39l-1.34.78a.27.27,0,0,1-.32,0,.55.55,0,0,1-.13-.43V137a1.3,1.3,0,0,1,.13-.56.81.81,0,0,1,.32-.39l1.34-.78a.24.24,0,0,1,.32,0,.53.53,0,0,1,.13.41v6.59l5-2.91V132.8a1.47,1.47,0,0,1,.13-.56.86.86,0,0,1,.32-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52,131.56a3.28,3.28,0,0,1,1.65-.52,2,2,0,0,1,1.29.46,3.12,3.12,0,0,1,.86,1.3,6.34,6.34,0,0,1,.38,2c0,.15,0,.35,0,.59v1.42c0,.23,0,.42,0,.58a12,12,0,0,1-.39,2.43,11.51,11.51,0,0,1-.85,2.28A9.56,9.56,0,0,1,98.17,144a6.36,6.36,0,0,1-1.65,1.39,3.28,3.28,0,0,1-1.66.52,1.94,1.94,0,0,1-1.28-.45,3,3,0,0,1-.86-1.29,6.63,6.63,0,0,1-.38-2c0-.15,0-.34,0-.56s0-.46,0-.7,0-.48,0-.73,0-.44,0-.6a11.26,11.26,0,0,1,.37-2.42,12.31,12.31,0,0,1,.87-2.29,9.53,9.53,0,0,1,1.28-2A6.57,6.57,0,0,1,96.52,131.56Zm2,4.6a3.33,3.33,0,0,0-.24-1.18,1.17,1.17,0,0,0-.47-.56.94.94,0,0,0-.62-.07,3,3,0,0,0-.68.28,4.47,4.47,0,0,0-.68.51,3.55,3.55,0,0,0-.62.78,4.69,4.69,0,0,0-.47,1.11,6.61,6.61,0,0,0-.25,1.46c0,.14,0,.32,0,.53s0,.42,0,.64,0,.44,0,.65,0,.37,0,.49a3.54,3.54,0,0,0,.25,1.18,1.12,1.12,0,0,0,.47.56.93.93,0,0,0,.62.06,2.28,2.28,0,0,0,.68-.28,3.45,3.45,0,0,0,.68-.51,3.54,3.54,0,0,0,.62-.77,5.15,5.15,0,0,0,.47-1.11,6.1,6.1,0,0,0,.24-1.46c0-.13,0-.3,0-.51v-1.29C98.55,136.46,98.54,136.29,98.53,136.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43,135.18a1.73,1.73,0,0,0,.27,1.11c.18.21.52.17,1-.11l1-.59a.25.25,0,0,1,.32,0,.55.55,0,0,1,.13.41v1.69a1.31,1.31,0,0,1-.13.57.83.83,0,0,1-.32.38l-1.23.72c-1.05.6-1.85.67-2.41.22s-.84-1.48-.84-3.09V131l-1.1.63a.23.23,0,0,1-.31,0,.55.55,0,0,1-.14-.41v-1.69a1.33,1.33,0,0,1,.14-.57.87.87,0,0,1,.31-.38l1.1-.64v-4.18a1.47,1.47,0,0,1,.13-.56.86.86,0,0,1,.32-.39l1.27-.73a.24.24,0,0,1,.31,0,.56.56,0,0,1,.14.41v4.18l2.14-1.24a.25.25,0,0,1,.32,0,.57.57,0,0,1,.13.42v1.69a1.27,1.27,0,0,1-.13.56.81.81,0,0,1-.32.39l-2.14,1.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39,131.05a14.69,14.69,0,0,1,.28-2.87,13.18,13.18,0,0,1,.82-2.67,9.64,9.64,0,0,1,1.29-2.22,5.74,5.74,0,0,1,1.69-1.52,2.75,2.75,0,0,1,1.69-.45,2,2,0,0,1,1.29.67,3.89,3.89,0,0,1,.82,1.6,8.3,8.3,0,0,1,.29,2.33v1.15a1.31,1.31,0,0,1-.13.57.78.78,0,0,1-.32.38l-5.56,3.21a2.47,2.47,0,0,0,.16,1,1.05,1.05,0,0,0,.43.51.89.89,0,0,0,.61.11,2,2,0,0,0,.72-.26,3.83,3.83,0,0,0,.86-.67,3.38,3.38,0,0,0,.55-.74,3.43,3.43,0,0,1,.3-.45,1.21,1.21,0,0,1,.32-.26l1.33-.77a.27.27,0,0,1,.33,0,.5.5,0,0,1,.12.41,4.2,4.2,0,0,1-.26,1.07,8.22,8.22,0,0,1-.72,1.52,10.1,10.1,0,0,1-1.19,1.61,6.39,6.39,0,0,1-1.64,1.33,3,3,0,0,1-1.69.48,1.84,1.84,0,0,1-1.29-.68,4.12,4.12,0,0,1-.82-1.72A10.68,10.68,0,0,1,109.39,131.05Zm4.08-6.2a3.09,3.09,0,0,0-.83.69,4.71,4.71,0,0,0-.57.9,4.56,4.56,0,0,0-.36,1,7.18,7.18,0,0,0-.16.9l3.77-2.17a6.77,6.77,0,0,0-.13-.74,1.32,1.32,0,0,0-.3-.59.81.81,0,0,0-.55-.25A1.64,1.64,0,0,0,113.47,124.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.54,130a1.31,1.31,0,0,1-.13.57.86.86,0,0,1-.32.39l-1.26.73a.24.24,0,0,1-.32,0,.53.53,0,0,1-.13-.41V114.44a1.24,1.24,0,0,1,.13-.56.86.86,0,0,1,.32-.39l1.26-.73a.24.24,0,0,1,.32,0,.53.53,0,0,1,.13.41Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.54,425.44l-57.07,0L24.37,450h0c.45,3,2.63,5.86,6.56,8.13,8.87,5.12,23.26,5.12,32.14,0,4.23-2.45,6.42-5.61,6.62-8.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,442.29a25,25,0,0,0,3.43-2.4l3.21-13.13a23.48,23.48,0,0,1-5.78,4.59c-12,6.95-31.33,7.12-43.78.56l1.45-5.85-.45-.62H18.47L24.37,450h0c.45,3,2.63,5.86,6.56,8.13,6.32,3.65,15.43,4.68,23.37,3.13-14.22,1.06-24-5.16-25.44-10.89-.59-2.28-1.6-7.34-1.6-7.34C39.14,449.07,57.23,448.83,68.58,442.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,418.16a12,12,0,0,1-1.91,4.44A21,21,0,0,1,69.44,429c-12.39,7.15-32.48,7.15-44.87,0a21.11,21.11,0,0,1-7.16-6.36,12.16,12.16,0,0,1-1.89-4.44h0c-1.11-5.37,1.92-11,9.06-15.1,12.39-7.16,32.48-7.16,44.87,0C76.58,407.18,79.61,412.79,78.51,418.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,422.6A21,21,0,0,1,69.44,429c-12.39,7.15-32.48,7.15-44.87,0a21.11,21.11,0,0,1-7.16-6.36,12.16,12.16,0,0,1-1.89-4.44h0l1.41,9.68c.64,3.89,3.54,7.68,8.71,10.66,11.81,6.81,31,6.81,42.75,0,5.1-2.94,8-6.69,8.69-10.53l.08-.49,1.36-9.32A12,12,0,0,1,76.6,422.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,405.21c-10.33-6-27.07-6-37.39,0-5.85,3.38-8.38,7.94-7.61,12.34.59,3.37,3.13,6.66,7.61,9.25,10.32,6,27.06,6,37.39,0,4.47-2.59,7-5.88,7.6-9.24C74.08,413.15,71.55,408.59,65.71,405.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45,421.63a17.77,17.77,0,0,0,5.87,5.17c10.32,6,27.06,6,37.39,0a17.83,17.83,0,0,0,5.86-5.17c-.08-3.57-2.47-7.12-7.19-9.85-9.59-5.54-25.15-5.54-34.74,0C24.92,414.51,22.53,418.07,22.45,421.63Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.82,331.67a5.25,5.25,0,0,1,0-.73c0-.25,0-.5-.07-.75-.06-.51-.13-1-.23-1.5a29.54,29.54,0,0,0-.73-2.95,2,2,0,0,0-.18-.57l-.18-.57c-.12-.39-.25-.77-.39-1.16-.18-.55-.38-1.1-.57-1.65a13,13,0,0,1-.53-1.6,2.67,2.67,0,0,0-.15-.62.85.85,0,0,1-.1-.28c-.06-.27-.11-.54-.17-.81-.11-.54-.24-1.07-.38-1.6-.29-1.07-.62-2.12-1-3.15-.31-.82-.64-1.62-1-2.41a8.38,8.38,0,0,0-2.73-3.67,1.14,1.14,0,0,0-1.09-.21c-.37.2-.44.69-.47,1.11l-.48,7.06a20.5,20.5,0,0,0,0,4.36,10.47,10.47,0,0,0,2.42,5.32,21.37,21.37,0,0,0,2.86,2.59c.77.61,1.55,1.2,2.3,1.84A9.55,9.55,0,0,0,32.82,331.67Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.71,316.82c-.06-.34-.13-.68-.21-1a7,7,0,0,0-.87-2c-.2-.32-.3-.67-.48-1a3.6,3.6,0,0,0-.72-.88,1.37,1.37,0,0,0-.6-.33.65.65,0,0,0-.64.18,1.1,1.1,0,0,0-.16.56,19.67,19.67,0,0,1-.75,3.74,12.84,12.84,0,0,1-.64,1.8,3.12,3.12,0,0,1-.34.47,2.43,2.43,0,0,0-.2.35,11,11,0,0,1-1,1.7,9.13,9.13,0,0,1-1,1.11c-1.09,1.1-2.47,1.95-3.3,3.26-1.25,2-1,4.49-1.09,6.71,0,.39,0,.77,0,1.15,0,3.06-.5,5.7.29,8.71,0,.21.27.73.6.53a4,4,0,0,0,.34-.23c1.69-1.2,2.64-3.2,3.42-5.06.21-.5.4-1,.6-1.5a3.74,3.74,0,0,1,.71-1,34.56,34.56,0,0,0,2-3.07A30.45,30.45,0,0,0,46,324.45a17.08,17.08,0,0,0,.89-5.26A12.56,12.56,0,0,0,46.71,316.82Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,340.89c.58,0,1.16.05,1.75.05,1.18,0,2.37,0,3.56,0,.59,0,1.19,0,1.78,0,.21,0,.4,0,.61,0a4.94,4.94,0,0,0,.86,0,.28.28,0,0,0,.16,0,.28.28,0,0,0,.09-.25,5.1,5.1,0,0,0-.57-2.36,4.59,4.59,0,0,0-.68-1A9.2,9.2,0,0,0,30,334.82a15.94,15.94,0,0,0-3.59-1.06l-9.69-2.07c-.45-.1-1-.17-1.29.17a1.17,1.17,0,0,0-.24.71,7.16,7.16,0,0,0,3.29,6.25A13.89,13.89,0,0,0,25.54,340.89Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.19,352.8A6.12,6.12,0,0,0,35,351.37a7.7,7.7,0,0,0-2.27-1.51,25.34,25.34,0,0,0-4.38-1.29A51.21,51.21,0,0,1,18.47,345a1.38,1.38,0,0,0-.68-.18c-.57.05-.79.76-.82,1.32a8.25,8.25,0,0,0,4.34,7.6c2.68,1.38,5.86,1.16,8.87,1.06h.13a25.18,25.18,0,0,1,3.25.05,14.38,14.38,0,0,1,1.6.25c.44.11,1.25.59,1.53,0a1.12,1.12,0,0,0,0-.68,5,5,0,0,0-.54-1.6Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.47,353.65A2.89,2.89,0,0,1,39,354a.92.92,0,0,1-.39.11.57.57,0,0,1-.5-.25c-.06-.09-.11-.19-.17-.29a5.63,5.63,0,0,1-.27-.61,7.16,7.16,0,0,1-.32-1.31c0-.11,0-.21,0-.32-.07-.5-.11-1-.16-1.51q0-.37-.09-.75a1.77,1.77,0,0,1,0-.56,4.72,4.72,0,0,0,0-.92,8.52,8.52,0,0,1,0-1.13c.29-3.34,2.72-6,4.72-8.7a41.54,41.54,0,0,0,4.6-7.83c.27-.61.72-1.34,1.39-1.24.52.08.8.65,1,1.16A17.64,17.64,0,0,1,48.43,341a24.45,24.45,0,0,1-3,6,33.43,33.43,0,0,1-2.06,2.68c-.22.25-.41.51-.64.75-.7.75-1.4,1.48-2.12,2.2-.29.3-.59.6-.89.89Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.33,362.88a27.9,27.9,0,0,0-6.87-1.36,16,16,0,0,1-6.68-2,1.26,1.26,0,0,0-.68-.27c-.49,0-.74.58-.8,1.06a6.54,6.54,0,0,0,1.11,4.11A12.33,12.33,0,0,0,31.69,370h0c1.52-.27,3-.81,4.51-1a6.12,6.12,0,0,1,1.13,0c.24,0,.64.15.83,0,.4-.43-.08-1-.18-1.46a5.15,5.15,0,0,0-.68-1.49A7.63,7.63,0,0,0,35,363.74,9.5,9.5,0,0,0,33.33,362.88Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.48,376.58c-2.31-.57-4.74-.69-7-1.49-1-.36-2-.85-2.95-1.26-.27-.11-.63-.2-.84,0a.75.75,0,0,0-.15.51,7.81,7.81,0,0,0,3.54,6.41,12.92,12.92,0,0,0,7.23,2.05c1.53,0,3.06-.13,4.58,0A3.41,3.41,0,0,1,39,383c.18.07.29.27.47.33.68.23.77-.74.69-1.16a5.56,5.56,0,0,0-.9-2.21,4.58,4.58,0,0,0-.78-.92,1.41,1.41,0,0,0-.38-.21c-.66-.32-1.2-.87-1.85-1.22A12.64,12.64,0,0,0,33.48,376.58Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.37,382.68a25,25,0,0,0-3.43-1.62l-7.8-3.22a1.22,1.22,0,0,0-1.14-.06,1.09,1.09,0,0,0-.37.82,8.14,8.14,0,0,0,.47,3.31c1.46,4.52,5.36,8.34,10.06,9.06,2,.3,4,.08,5.93.54.77.18,2,.43,2.05-.74a1.73,1.73,0,0,0-.32-.84,12.39,12.39,0,0,1-.43-1.21,12.48,12.48,0,0,0-2.76-4.25A12.19,12.19,0,0,0,24.37,382.68Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,395.9a19,19,0,0,0-4.9-1.22L19,394l-1.74-.27a.65.65,0,0,1-.24-.06,1.43,1.43,0,0,0-.73-.17c-.34.06-.39.28-.42.58a5.06,5.06,0,0,0,.17,1.77,6.45,6.45,0,0,0,1.9,3.08,11.28,11.28,0,0,0,5.41,2.47,20.82,20.82,0,0,0,4.85.39c1.36-.05,2.73-.35,3.4-1.66s-.44-2.24-1.26-3A7.78,7.78,0,0,0,28.35,395.9Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47,386.43a1.8,1.8,0,0,1,.1-.95,1.11,1.11,0,0,1,1.12-.55,2.15,2.15,0,0,1,1.17.59c1.38,1.24,1.73,3.24,1.9,5.09a17.07,17.07,0,0,1-.2,5.66c-.33,1.36-1,3.11-2.5,3.43a2.66,2.66,0,0,1-2.8-1.33c-.87-1.57-.11-3.66.29-5.26a25.11,25.11,0,0,0,.94-6C33.49,386.9,33.48,386.66,33.47,386.43Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19,406.39a21.77,21.77,0,0,0-5.94-1.31L22,404.81a1.24,1.24,0,0,0-.47,0c-.5.16-.54.85-.38,1.34.67,2.12,3,3.26,5.19,3.68s4.49.37,6.54,1.23c.48.21,1.23.54,1.55-.08s-.2-.86-.41-1.26a7,7,0,0,0-2.2-2.42A9,9,0,0,0,30.19,406.39Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65,403.73c.71-1.74,2.22-3.15,2.52-5a1,1,0,0,1,1,.43,3,3,0,0,1,.4,1.06,21.33,21.33,0,0,1,.68,4.33,7,7,0,0,1-1.13,4.17,2.48,2.48,0,0,1-1.8,1.16,2.12,2.12,0,0,1-1.7-.67c-.67-.74-.46-1.82-.42-2.74A8.25,8.25,0,0,1,34.65,403.73Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,321.2c1.81-3.83,5.12-6.89,6.46-10.92a1.27,1.27,0,0,1,.3-.56.77.77,0,0,1,1,.12,2.14,2.14,0,0,1,.49,1A16.83,16.83,0,0,1,80.5,320a31.61,31.61,0,0,1-1.65,4,76,76,0,0,1-3.1,7,13.6,13.6,0,0,1-2.6,3.33c-.77.7-2.12,1.91-3,.61a3.59,3.59,0,0,1-.32-1.92c0-.78,0-1.55,0-2.33a32.25,32.25,0,0,1,.43-4.6,20.11,20.11,0,0,1,1.28-4.37C71.69,321.55,71.76,321.37,71.85,321.2Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,335.69a19.51,19.51,0,0,0-2.52-5.82L59,322.67c-.11-.19-.25-.4-.46-.41s-.4.19-.52.39c-2,3.16-1.87,7.26-.57,10.74a28.91,28.91,0,0,0,6.18,9.18,1.17,1.17,0,0,0,1.25.46,1.63,1.63,0,0,0,.81-1.28,1.54,1.54,0,0,0,0-.48,6.45,6.45,0,0,1,.08-1.39c0-.57.1-1.14.11-1.71A11.43,11.43,0,0,0,65.67,335.69Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.86,333.14l4-2a.59.59,0,0,1,.34-.08c.2,0,.29.26.33.46a6.16,6.16,0,0,1-.7,4.15A13.4,13.4,0,0,1,83.12,339a32.43,32.43,0,0,1-3.35,2.84A31.14,31.14,0,0,1,76,344.24,28.48,28.48,0,0,1,72,346a26.3,26.3,0,0,1-4.26,1.07c-.77.12-1.79.25-1.94-.76a4.46,4.46,0,0,1,.78-2.63A11.54,11.54,0,0,1,69,340.92a34.57,34.57,0,0,1,3.69-2.78c1.28-.84,2.61-1.62,4-2.36s2.75-1.44,4.13-2.13Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,348.17a26.48,26.48,0,0,0-1.34-3.32,57.37,57.37,0,0,1-2.89-8c-.45-.05-.81.33-1.09.69a13.69,13.69,0,0,0-2.9,7.54,10,10,0,0,0,2.73,7.5c1.4,1.42,3.31,2.38,4.31,4.11.19.32.37.7.73.81a.52.52,0,0,0,.57-.26c.11-.21-.06-.41,0-.63.07-.69.17-1.38.24-2.07a20.71,20.71,0,0,0,.08-4.09A12.36,12.36,0,0,0,58.17,348.17Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.69,353.66c2-1.69,4.82-2.18,7.46-2.51s5.39-.59,7.68-1.95a1.68,1.68,0,0,1,.82-.33c.77,0,1.1,1,1,1.78a7.11,7.11,0,0,1-1.5,2.91,13.3,13.3,0,0,1-2.2,2.42c-2.92,2.4-7,2.6-10.79,2.7l-2.72.06-1.37,0a9.84,9.84,0,0,1-1.33,0c-.68-.07-.13-.88,0-1.21a21.72,21.72,0,0,1,1.17-2A9.65,9.65,0,0,1,62.69,353.66Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,363.57a16.09,16.09,0,0,0-1.64-3.23l-3.28-5.45c-.35-.57-.8-1.21-1.47-1.24-1.56,4.2-2.42,9.05-.41,13.05a20.59,20.59,0,0,0,2.54,3.63L51,373.72c.38.47,1.1,1,1.72.63.29-.16.34-.52.4-.81a9.39,9.39,0,0,0,.17-1.4,5.05,5.05,0,0,0,0-1,15.2,15.2,0,0,1-.23-3A14.1,14.1,0,0,0,52.46,363.57Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.29,365.5a11.9,11.9,0,0,1,2.94-1.12c1.2-.25,2.44-.26,3.65-.41,2-.25,3.93-.87,5.92-1.17a1,1,0,0,1,.61,0,1,1,0,0,1,.39.8,7,7,0,0,1-1,3.86,13.93,13.93,0,0,1-9.26,6.78,35.55,35.55,0,0,1-5.36.44,26.66,26.66,0,0,0-2.68.23,12,12,0,0,0-1.33.26,1.29,1.29,0,0,1-.82.05c-.44-.2-.46-.81-.42-1.21a4.91,4.91,0,0,1,.65-1.82,16.52,16.52,0,0,1,6.24-6.46Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3,375.72a35.62,35.62,0,0,0-.55,5.55,18.24,18.24,0,0,0,1,6.93,24.33,24.33,0,0,0,4.19,6.42.7.7,0,0,0,.36.28c.32.08.56-.28.69-.59a16.26,16.26,0,0,0,.91-8.73,16.74,16.74,0,0,0-1.34-4.33c-.29-.62-.72-1.2-1-1.84-.06-.15-.08-.31-.14-.46a10.77,10.77,0,0,0-.77-1.36,19.36,19.36,0,0,1-1.33-3,1.73,1.73,0,0,0-.56-.95.63.63,0,0,0-.65,0c-.23.13-.2.34-.3.55a6.36,6.36,0,0,0-.34.75A7.13,7.13,0,0,0,43.3,375.72Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,382.69a10,10,0,0,1,2.87-3.27,12.24,12.24,0,0,1,3.11-1.32l8.12-2.63c.52,3-.88,6-2.94,8.25a29.16,29.16,0,0,1-7,5.1c-1.8,1-3.63,1.82-4.63,2.49-.45.31-.89.62-1.32.95s-1,.79-1.31.41c-.17-.19-.06-.51,0-.73s.13-.62.21-.93.22-.78.33-1.17.21-.77.3-1.16c0-.19.07-.38.11-.58a17.21,17.21,0,0,1,.81-2.8A18.3,18.3,0,0,1,53.49,382.69Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,410.18a15.56,15.56,0,0,0-.55-3.72,8.3,8.3,0,0,0-2.5-4.46,3.23,3.23,0,0,0-2.5-.7c.25,1.77.51,3.53.77,5.3,0,.19,0,.38.08.56A9.47,9.47,0,0,0,51.52,411a5.79,5.79,0,0,0,.69.71A9,9,0,0,0,53.77,413l.26.15a.9.9,0,0,0,.42.13c.5,0,.43-.79.47-1.12a17.47,17.47,0,0,0,.08-1.77A1.27,1.27,0,0,1,55,410.18Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44,403.51a14.7,14.7,0,0,0,2.83-1.62c.19-.14.44-.29.65-.17a.56.56,0,0,1,.22.35,4.48,4.48,0,0,1-1.15,3.7,14.63,14.63,0,0,1-3.42,3.29,10.35,10.35,0,0,1-4.31,1.7c-.91.12-2.92.29-2.54-1.2a5.18,5.18,0,0,1,.89-1.61,14.61,14.61,0,0,1,1.43-1.7c1.32-1.31,3.13-1.82,4.81-2.49Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,393.81a15.29,15.29,0,0,1,9.88.34,4.32,4.32,0,0,1,2.12,1.31,1.7,1.7,0,0,1-.12,2.29,2.75,2.75,0,0,1-1,.39L59.25,401.9A3.48,3.48,0,0,1,58,402c-.2,0-.38-.14-.57-.16s-.32.06-.43-.13a.76.76,0,0,1-.06-.37,4.3,4.3,0,0,1,.08-.95,1.62,1.62,0,0,1,.15-.42c.18-.33.31-.69.47-1a10,10,0,0,1,3.4-3.85A11.14,11.14,0,0,1,63.68,393.81Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,384.63c2.63-1.38,5.71-1.51,8.68-1.61a.7.7,0,0,1,.49.12.54.54,0,0,1,.13.33A4.55,4.55,0,0,1,74.31,387a11.68,11.68,0,0,1-3.78,2.8,23.21,23.21,0,0,1-4.34,1.34l-4,1c-.26.06-.86.38-1.11.19s0-1,0-1.25a9.23,9.23,0,0,1,.75-1.51,12.06,12.06,0,0,1,1.68-2.68A10,10,0,0,1,66.42,384.63Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,393.11c-.08-.05-.17-.11-.26-.07s-.09.11-.11.19a2.88,2.88,0,0,0-.12.64c0,.06,0,.12,0,.17a3.12,3.12,0,0,1-.11.53,4.87,4.87,0,0,0-.11,1.21,5.54,5.54,0,0,0,.16,1.28,9,9,0,0,0,1.24,2.82,5,5,0,0,0,.43.6c.18.2.39.38.58.57a7.53,7.53,0,0,1,1.08,1.44c.09.15.22.31.39.29a.41.41,0,0,0,.23-.2,1.69,1.69,0,0,0,.38-.61c.05-.24.11-.48.14-.73,0,0,0-.07,0-.11a9,9,0,0,0-.46-3.72,8.29,8.29,0,0,0-.79-1.71A9.24,9.24,0,0,0,52,393.11Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.82,331.67a5.25,5.25,0,0,1,0-.73c0-.25,0-.5-.07-.75-.06-.51-.13-1-.23-1.5a29.54,29.54,0,0,0-.73-2.95,2,2,0,0,0-.18-.57l-.18-.57c-.12-.39-.25-.77-.39-1.16-.18-.55-.38-1.1-.57-1.65a13,13,0,0,1-.53-1.6,2.67,2.67,0,0,0-.15-.62.85.85,0,0,1-.1-.28c-.06-.27-.11-.54-.17-.81-.11-.54-.24-1.07-.38-1.6-.29-1.07-.62-2.12-1-3.15-.31-.82-.64-1.62-1-2.41a8.38,8.38,0,0,0-2.73-3.67,1.14,1.14,0,0,0-1.09-.21c-.37.2-.44.69-.47,1.11l-.48,7.06a20.5,20.5,0,0,0,0,4.36,10.47,10.47,0,0,0,2.42,5.32,21.37,21.37,0,0,0,2.86,2.59c.77.61,1.55,1.2,2.3,1.84A9.55,9.55,0,0,0,32.82,331.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.19,352.8A6.12,6.12,0,0,0,35,351.37a7.7,7.7,0,0,0-2.27-1.51,25.34,25.34,0,0,0-4.38-1.29A51.21,51.21,0,0,1,18.47,345a1.38,1.38,0,0,0-.68-.18c-.57.05-.79.76-.82,1.32a8.25,8.25,0,0,0,4.34,7.6c2.68,1.38,5.86,1.16,8.87,1.06h.13a25.18,25.18,0,0,1,3.25.05,14.38,14.38,0,0,1,1.6.25c.44.11,1.25.59,1.53,0a1.12,1.12,0,0,0,0-.68,5,5,0,0,0-.54-1.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.47,353.65A2.89,2.89,0,0,1,39,354a.92.92,0,0,1-.39.11.57.57,0,0,1-.5-.25c-.06-.09-.11-.19-.17-.29a5.63,5.63,0,0,1-.27-.61,7.16,7.16,0,0,1-.32-1.31c0-.11,0-.21,0-.32-.07-.5-.11-1-.16-1.51q0-.37-.09-.75a1.77,1.77,0,0,1,0-.56,4.72,4.72,0,0,0,0-.92,8.52,8.52,0,0,1,0-1.13c.29-3.34,2.72-6,4.72-8.7a41.54,41.54,0,0,0,4.6-7.83c.27-.61.72-1.34,1.39-1.24.52.08.8.65,1,1.16A17.64,17.64,0,0,1,48.43,341a24.45,24.45,0,0,1-3,6,33.43,33.43,0,0,1-2.06,2.68c-.22.25-.41.51-.64.75-.7.75-1.4,1.48-2.12,2.2-.29.3-.59.6-.89.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.48,376.58c-2.31-.57-4.74-.69-7-1.49-1-.36-2-.85-2.95-1.26-.27-.11-.63-.2-.84,0a.75.75,0,0,0-.15.51,7.81,7.81,0,0,0,3.54,6.41,12.92,12.92,0,0,0,7.23,2.05c1.53,0,3.06-.13,4.58,0A3.41,3.41,0,0,1,39,383c.18.07.29.27.47.33.68.23.77-.74.69-1.16a5.56,5.56,0,0,0-.9-2.21,4.58,4.58,0,0,0-.78-.92,1.41,1.41,0,0,0-.38-.21c-.66-.32-1.2-.87-1.85-1.22A12.64,12.64,0,0,0,33.48,376.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.37,382.68a25,25,0,0,0-3.43-1.62l-7.8-3.22a1.22,1.22,0,0,0-1.14-.06,1.09,1.09,0,0,0-.37.82,8.14,8.14,0,0,0,.47,3.31c1.46,4.52,5.36,8.34,10.06,9.06,2,.3,4,.08,5.93.54.77.18,2,.43,2.05-.74a1.73,1.73,0,0,0-.32-.84,12.39,12.39,0,0,1-.43-1.21,12.48,12.48,0,0,0-2.76-4.25A12.19,12.19,0,0,0,24.37,382.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,395.9a19,19,0,0,0-4.9-1.22L19,394l-1.74-.27a.65.65,0,0,1-.24-.06,1.43,1.43,0,0,0-.73-.17c-.34.06-.39.28-.42.58a5.06,5.06,0,0,0,.17,1.77,6.45,6.45,0,0,0,1.9,3.08,11.28,11.28,0,0,0,5.41,2.47,20.82,20.82,0,0,0,4.85.39c1.36-.05,2.73-.35,3.4-1.66s-.44-2.24-1.26-3A7.78,7.78,0,0,0,28.35,395.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19,406.39a21.77,21.77,0,0,0-5.94-1.31L22,404.81a1.24,1.24,0,0,0-.47,0c-.5.16-.54.85-.38,1.34.67,2.12,3,3.26,5.19,3.68s4.49.37,6.54,1.23c.48.21,1.23.54,1.55-.08s-.2-.86-.41-1.26a7,7,0,0,0-2.2-2.42A9,9,0,0,0,30.19,406.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,321.2c1.81-3.83,5.12-6.89,6.46-10.92a1.27,1.27,0,0,1,.3-.56.77.77,0,0,1,1,.12,2.14,2.14,0,0,1,.49,1A16.83,16.83,0,0,1,80.5,320a31.61,31.61,0,0,1-1.65,4,76,76,0,0,1-3.1,7,13.6,13.6,0,0,1-2.6,3.33c-.77.7-2.12,1.91-3,.61a3.59,3.59,0,0,1-.32-1.92c0-.78,0-1.55,0-2.33a32.25,32.25,0,0,1,.43-4.6,20.11,20.11,0,0,1,1.28-4.37C71.69,321.55,71.76,321.37,71.85,321.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,335.69a19.51,19.51,0,0,0-2.52-5.82L59,322.67c-.11-.19-.25-.4-.46-.41s-.4.19-.52.39c-2,3.16-1.87,7.26-.57,10.74a28.91,28.91,0,0,0,6.18,9.18,1.17,1.17,0,0,0,1.25.46,1.63,1.63,0,0,0,.81-1.28,1.54,1.54,0,0,0,0-.48,6.45,6.45,0,0,1,.08-1.39c0-.57.1-1.14.11-1.71A11.43,11.43,0,0,0,65.67,335.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.69,353.66c2-1.69,4.82-2.18,7.46-2.51s5.39-.59,7.68-1.95a1.68,1.68,0,0,1,.82-.33c.77,0,1.1,1,1,1.78a7.11,7.11,0,0,1-1.5,2.91,13.3,13.3,0,0,1-2.2,2.42c-2.92,2.4-7,2.6-10.79,2.7l-2.72.06-1.37,0a9.84,9.84,0,0,1-1.33,0c-.68-.07-.13-.88,0-1.21a21.72,21.72,0,0,1,1.17-2A9.65,9.65,0,0,1,62.69,353.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3,375.72a35.62,35.62,0,0,0-.55,5.55,18.24,18.24,0,0,0,1,6.93,24.33,24.33,0,0,0,4.19,6.42.7.7,0,0,0,.36.28c.32.08.56-.28.69-.59a16.26,16.26,0,0,0,.91-8.73,16.74,16.74,0,0,0-1.34-4.33c-.29-.62-.72-1.2-1-1.84-.06-.15-.08-.31-.14-.46a10.77,10.77,0,0,0-.77-1.36,19.36,19.36,0,0,1-1.33-3,1.73,1.73,0,0,0-.56-.95.63.63,0,0,0-.65,0c-.23.13-.2.34-.3.55a6.36,6.36,0,0,0-.34.75A7.13,7.13,0,0,0,43.3,375.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,382.69a10,10,0,0,1,2.87-3.27,12.24,12.24,0,0,1,3.11-1.32l8.12-2.63c.52,3-.88,6-2.94,8.25a29.16,29.16,0,0,1-7,5.1c-1.8,1-3.63,1.82-4.63,2.49-.45.31-.89.62-1.32.95s-1,.79-1.31.41c-.17-.19-.06-.51,0-.73s.13-.62.21-.93.22-.78.33-1.17.21-.77.3-1.16c0-.19.07-.38.11-.58a17.21,17.21,0,0,1,.81-2.8A18.3,18.3,0,0,1,53.49,382.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,410.18a15.56,15.56,0,0,0-.55-3.72,8.3,8.3,0,0,0-2.5-4.46,3.23,3.23,0,0,0-2.5-.7c.25,1.77.51,3.53.77,5.3,0,.19,0,.38.08.56A9.47,9.47,0,0,0,51.52,411a5.79,5.79,0,0,0,.69.71A9,9,0,0,0,53.77,413l.26.15a.9.9,0,0,0,.42.13c.5,0,.43-.79.47-1.12a17.47,17.47,0,0,0,.08-1.77A1.27,1.27,0,0,1,55,410.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44,403.51a14.7,14.7,0,0,0,2.83-1.62c.19-.14.44-.29.65-.17a.56.56,0,0,1,.22.35,4.48,4.48,0,0,1-1.15,3.7,14.63,14.63,0,0,1-3.42,3.29,10.35,10.35,0,0,1-4.31,1.7c-.91.12-2.92.29-2.54-1.2a5.18,5.18,0,0,1,.89-1.61,14.61,14.61,0,0,1,1.43-1.7c1.32-1.31,3.13-1.82,4.81-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,384.63c2.63-1.38,5.71-1.51,8.68-1.61a.7.7,0,0,1,.49.12.54.54,0,0,1,.13.33A4.55,4.55,0,0,1,74.31,387a11.68,11.68,0,0,1-3.78,2.8,23.21,23.21,0,0,1-4.34,1.34l-4,1c-.26.06-.86.38-1.11.19s0-1,0-1.25a9.23,9.23,0,0,1,.75-1.51,12.06,12.06,0,0,1,1.68-2.68A10,10,0,0,1,66.42,384.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,393.11c-.08-.05-.17-.11-.26-.07s-.09.11-.11.19a2.88,2.88,0,0,0-.12.64c0,.06,0,.12,0,.17a3.12,3.12,0,0,1-.11.53,4.87,4.87,0,0,0-.11,1.21,5.54,5.54,0,0,0,.16,1.28,9,9,0,0,0,1.24,2.82,5,5,0,0,0,.43.6c.18.2.39.38.58.57a7.53,7.53,0,0,1,1.08,1.44c.09.15.22.31.39.29a.41.41,0,0,0,.23-.2,1.69,1.69,0,0,0,.38-.61c.05-.24.11-.48.14-.73,0,0,0-.07,0-.11a9,9,0,0,0-.46-3.72,8.29,8.29,0,0,0-.79-1.71A9.24,9.24,0,0,0,52,393.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.71,316.82c-.06-.34-.13-.68-.21-1a7,7,0,0,0-.87-2c-.2-.32-.3-.67-.48-1a3.6,3.6,0,0,0-.72-.88,1.37,1.37,0,0,0-.6-.33.65.65,0,0,0-.64.18,1.1,1.1,0,0,0-.16.56,19.67,19.67,0,0,1-.75,3.74,12.84,12.84,0,0,1-.64,1.8,3.12,3.12,0,0,1-.34.47,2.43,2.43,0,0,0-.2.35,11,11,0,0,1-1,1.7,9.13,9.13,0,0,1-1,1.11c-1.09,1.1-2.47,1.95-3.3,3.26-1.25,2-1,4.49-1.09,6.71,0,.39,0,.77,0,1.15,0,3.06-.5,5.7.29,8.71,0,.21.27.73.6.53a4,4,0,0,0,.34-.23c1.69-1.2,2.64-3.2,3.42-5.06.21-.5.4-1,.6-1.5a3.74,3.74,0,0,1,.71-1,34.56,34.56,0,0,0,2-3.07A30.45,30.45,0,0,0,46,324.45a17.08,17.08,0,0,0,.89-5.26A12.56,12.56,0,0,0,46.71,316.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,340.89c.58,0,1.16.05,1.75.05,1.18,0,2.37,0,3.56,0,.59,0,1.19,0,1.78,0,.21,0,.4,0,.61,0a4.94,4.94,0,0,0,.86,0,.28.28,0,0,0,.16,0,.28.28,0,0,0,.09-.25,5.1,5.1,0,0,0-.57-2.36,4.59,4.59,0,0,0-.68-1A9.2,9.2,0,0,0,30,334.82a15.94,15.94,0,0,0-3.59-1.06l-9.69-2.07c-.45-.1-1-.17-1.29.17a1.17,1.17,0,0,0-.24.71,7.16,7.16,0,0,0,3.29,6.25A13.89,13.89,0,0,0,25.54,340.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.33,362.88a27.9,27.9,0,0,0-6.87-1.36,16,16,0,0,1-6.68-2,1.26,1.26,0,0,0-.68-.27c-.49,0-.74.58-.8,1.06a6.54,6.54,0,0,0,1.11,4.11A12.33,12.33,0,0,0,31.69,370h0c1.52-.27,3-.81,4.51-1a6.12,6.12,0,0,1,1.13,0c.24,0,.64.15.83,0,.4-.43-.08-1-.18-1.46a5.15,5.15,0,0,0-.68-1.49A7.63,7.63,0,0,0,35,363.74,9.5,9.5,0,0,0,33.33,362.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47,386.43a1.8,1.8,0,0,1,.1-.95,1.11,1.11,0,0,1,1.12-.55,2.15,2.15,0,0,1,1.17.59c1.38,1.24,1.73,3.24,1.9,5.09a17.07,17.07,0,0,1-.2,5.66c-.33,1.36-1,3.11-2.5,3.43a2.66,2.66,0,0,1-2.8-1.33c-.87-1.57-.11-3.66.29-5.26a25.11,25.11,0,0,0,.94-6C33.49,386.9,33.48,386.66,33.47,386.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65,403.73c.71-1.74,2.22-3.15,2.52-5a1,1,0,0,1,1,.43,3,3,0,0,1,.4,1.06,21.33,21.33,0,0,1,.68,4.33,7,7,0,0,1-1.13,4.17,2.48,2.48,0,0,1-1.8,1.16,2.12,2.12,0,0,1-1.7-.67c-.67-.74-.46-1.82-.42-2.74A8.25,8.25,0,0,1,34.65,403.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.86,333.14l4-2a.59.59,0,0,1,.34-.08c.2,0,.29.26.33.46a6.16,6.16,0,0,1-.7,4.15A13.4,13.4,0,0,1,83.12,339a32.43,32.43,0,0,1-3.35,2.84A31.14,31.14,0,0,1,76,344.24,28.48,28.48,0,0,1,72,346a26.3,26.3,0,0,1-4.26,1.07c-.77.12-1.79.25-1.94-.76a4.46,4.46,0,0,1,.78-2.63A11.54,11.54,0,0,1,69,340.92a34.57,34.57,0,0,1,3.69-2.78c1.28-.84,2.61-1.62,4-2.36s2.75-1.44,4.13-2.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,348.17a26.48,26.48,0,0,0-1.34-3.32,57.37,57.37,0,0,1-2.89-8c-.45-.05-.81.33-1.09.69a13.69,13.69,0,0,0-2.9,7.54,10,10,0,0,0,2.73,7.5c1.4,1.42,3.31,2.38,4.31,4.11.19.32.37.7.73.81a.52.52,0,0,0,.57-.26c.11-.21-.06-.41,0-.63.07-.69.17-1.38.24-2.07a20.71,20.71,0,0,0,.08-4.09A12.36,12.36,0,0,0,58.17,348.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,363.57a16.09,16.09,0,0,0-1.64-3.23l-3.28-5.45c-.35-.57-.8-1.21-1.47-1.24-1.56,4.2-2.42,9.05-.41,13.05a20.59,20.59,0,0,0,2.54,3.63L51,373.72c.38.47,1.1,1,1.72.63.29-.16.34-.52.4-.81a9.39,9.39,0,0,0,.17-1.4,5.05,5.05,0,0,0,0-1,15.2,15.2,0,0,1-.23-3A14.1,14.1,0,0,0,52.46,363.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.29,365.5a11.9,11.9,0,0,1,2.94-1.12c1.2-.25,2.44-.26,3.65-.41,2-.25,3.93-.87,5.92-1.17a1,1,0,0,1,.61,0,1,1,0,0,1,.39.8,7,7,0,0,1-1,3.86,13.93,13.93,0,0,1-9.26,6.78,35.55,35.55,0,0,1-5.36.44,26.66,26.66,0,0,0-2.68.23,12,12,0,0,0-1.33.26,1.29,1.29,0,0,1-.82.05c-.44-.2-.46-.81-.42-1.21a4.91,4.91,0,0,1,.65-1.82,16.52,16.52,0,0,1,6.24-6.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,393.81a15.29,15.29,0,0,1,9.88.34,4.32,4.32,0,0,1,2.12,1.31,1.7,1.7,0,0,1-.12,2.29,2.75,2.75,0,0,1-1,.39L59.25,401.9A3.48,3.48,0,0,1,58,402c-.2,0-.38-.14-.57-.16s-.32.06-.43-.13a.76.76,0,0,1-.06-.37,4.3,4.3,0,0,1,.08-.95,1.62,1.62,0,0,1,.15-.42c.18-.33.31-.69.47-1a10,10,0,0,1,3.4-3.85A11.14,11.14,0,0,1,63.68,393.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.81,423.16c-.16-.76-.26-1.55-.48-2.3s-.51-1.67-.75-2.51c-.45-1.53-.84-3.08-1.19-4.64q-1.08-4.77-1.7-9.62c-.83-6.51-1.13-13.06-1.4-19.6S40.73,371.34,40,364.8q-.63-5.94-1.69-11.82a20.75,20.75,0,0,1,2.52-5.6,49.51,49.51,0,0,0,3.85-7c0-.1-.06-.28-.14-.13-1.25,2.42-3.23,4.4-4.76,6.64a16.14,16.14,0,0,0-1.9,3.78c-.38-1.94-.77-3.88-1.22-5.8q-.42-1.83-.9-3.63c.1-.67.21-1.34.27-2a23.15,23.15,0,0,1,.36-2.48A24.92,24.92,0,0,1,38,332c1.26-3,3.42-5.58,4.42-8.69.05-.15-.15-.39-.23-.16a19.55,19.55,0,0,1-2.82,4.59,21.1,21.1,0,0,0-2.72,4.42A20.8,20.8,0,0,0,35.2,337c-.08.45-.15.89-.2,1.34a115.38,115.38,0,0,0-5.74-15.69c-.08-.18-.23.07-.2.18,1.71,5.63,3.31,11.29,4.72,17l-.31-.21A11.18,11.18,0,0,0,31,338.4c-2.21-.77-4.5-1.29-6.73-2-.13,0-.19.3-.07.34,2.08.72,4.14,1.48,6.19,2.24a16.53,16.53,0,0,1,2.41,1,7.21,7.21,0,0,1,1.09.74l.18.19c1.07,4.44,2,8.91,2.78,13.41a10,10,0,0,0-5.61-3.06c-1.53-.31-3.09-.37-4.63-.58a14.09,14.09,0,0,1-4.3-1.35c-.08,0-.12.15-.07.2,2.11,1.92,5.54,2,8.21,2.45a11,11,0,0,1,4.14,1.4A9,9,0,0,1,37.12,356c.36,2.26.69,4.52,1,6.8.24,2.1.42,4.2.58,6.3a7.15,7.15,0,0,0-2.36-1.65,15,15,0,0,0-4.09-1.18c-2.86-.46-5.88-.56-8.33-2.3,0,0-.07.06,0,.08,2,1.95,4.89,2.48,7.57,3a23.05,23.05,0,0,1,4,1,9.65,9.65,0,0,1,1.76.88,20.4,20.4,0,0,1,1.6,1.35c.27,3.82.45,7.64.61,11.46a6.55,6.55,0,0,0-.83-.72,7.44,7.44,0,0,0-2.5-1.17c-2.23-.57-4.59-.24-6.78-1-.1,0-.15.2-.05.24,2,.82,4.13.87,6.2,1.37a9,9,0,0,1,2.4.94,4.81,4.81,0,0,1,1,.75,6.25,6.25,0,0,1,.63.83c.26,6.19.52,12.39,1.2,18.56.4,3.52.93,7,1.67,10.51.37,1.73.81,3.43,1.31,5.12.3,1,.62,2,1,3a22.51,22.51,0,0,0,1.51,3.08C46.27,423.66,46.92,423.69,46.81,423.16Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.81,423.16c-.16-.76-.26-1.55-.48-2.3s-.51-1.67-.75-2.51c-.45-1.53-.84-3.08-1.19-4.64q-1.08-4.77-1.7-9.62c-.83-6.51-1.13-13.06-1.4-19.6S40.73,371.34,40,364.8q-.63-5.94-1.69-11.82a20.75,20.75,0,0,1,2.52-5.6,49.51,49.51,0,0,0,3.85-7c0-.1-.06-.28-.14-.13-1.25,2.42-3.23,4.4-4.76,6.64a16.14,16.14,0,0,0-1.9,3.78c-.38-1.94-.77-3.88-1.22-5.8q-.42-1.83-.9-3.63c.1-.67.21-1.34.27-2a23.15,23.15,0,0,1,.36-2.48A24.92,24.92,0,0,1,38,332c1.26-3,3.42-5.58,4.42-8.69.05-.15-.15-.39-.23-.16a19.55,19.55,0,0,1-2.82,4.59,21.1,21.1,0,0,0-2.72,4.42A20.8,20.8,0,0,0,35.2,337c-.08.45-.15.89-.2,1.34a115.38,115.38,0,0,0-5.74-15.69c-.08-.18-.23.07-.2.18,1.71,5.63,3.31,11.29,4.72,17l-.31-.21A11.18,11.18,0,0,0,31,338.4c-2.21-.77-4.5-1.29-6.73-2-.13,0-.19.3-.07.34,2.08.72,4.14,1.48,6.19,2.24a16.53,16.53,0,0,1,2.41,1,7.21,7.21,0,0,1,1.09.74l.18.19c1.07,4.44,2,8.91,2.78,13.41a10,10,0,0,0-5.61-3.06c-1.53-.31-3.09-.37-4.63-.58a14.09,14.09,0,0,1-4.3-1.35c-.08,0-.12.15-.07.2,2.11,1.92,5.54,2,8.21,2.45a11,11,0,0,1,4.14,1.4A9,9,0,0,1,37.12,356c.36,2.26.69,4.52,1,6.8.24,2.1.42,4.2.58,6.3a7.15,7.15,0,0,0-2.36-1.65,15,15,0,0,0-4.09-1.18c-2.86-.46-5.88-.56-8.33-2.3,0,0-.07.06,0,.08,2,1.95,4.89,2.48,7.57,3a23.05,23.05,0,0,1,4,1,9.65,9.65,0,0,1,1.76.88,20.4,20.4,0,0,1,1.6,1.35c.27,3.82.45,7.64.61,11.46a6.55,6.55,0,0,0-.83-.72,7.44,7.44,0,0,0-2.5-1.17c-2.23-.57-4.59-.24-6.78-1-.1,0-.15.2-.05.24,2,.82,4.13.87,6.2,1.37a9,9,0,0,1,2.4.94,4.81,4.81,0,0,1,1,.75,6.25,6.25,0,0,1,.63.83c.26,6.19.52,12.39,1.2,18.56.4,3.52.93,7,1.67,10.51.37,1.73.81,3.43,1.31,5.12.3,1,.62,2,1,3a22.51,22.51,0,0,0,1.51,3.08C46.27,423.66,46.92,423.69,46.81,423.16Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59,424.51a20,20,0,0,1-3.07-7.11c-.54-2.15-.94-4.33-1.35-6.51a6.72,6.72,0,0,1,.34-1.39q.29-.75.63-1.47l.37-.71a3.28,3.28,0,0,0,.3-1.1s0-.12-.07-.1c-.61.2-.91.82-1.23,1.33a9.41,9.41,0,0,0-.73,1.41c-.48-2.47-1-4.95-1.47-7.42h0c.09-.41.16-.82.28-1.21.25-.79.65-1.51,1-2.27a11.17,11.17,0,0,0,.76-2.51A7,7,0,0,0,35.5,393c0-.22-.23,0-.21.15.14.9-.6,1.74-1,2.49s-.73,1.37-1.08,2.07c-.16.32-.32.65-.47,1a23.83,23.83,0,0,0-2-6.83,11.58,11.58,0,0,0-2.57-3.25,12.76,12.76,0,0,0-2-1.37,17.83,17.83,0,0,0-2.45-1c-.08,0-.13.17-.06.21.62.4,1.19.88,1.81,1.27a18,18,0,0,1,1.94,1.4,7.34,7.34,0,0,1,2.17,3,38.44,38.44,0,0,1,1.8,7.25,18.58,18.58,0,0,0-3.54-.6,10.91,10.91,0,0,1-3.67-1.06c-.16-.08-.23.27-.12.35a8.62,8.62,0,0,0,3.73,1.48c.67.13,1.34.26,2,.41s1.2.33,1.8.5c.54,2.85,1.11,5.68,1.67,8.52l.18.94a5.92,5.92,0,0,0-.48-.35,5.47,5.47,0,0,0-1.39-.69,2.54,2.54,0,0,0-.77-.18c-.24,0-.48,0-.72,0s-.19.35,0,.39a8,8,0,0,1,1.41.47,7.09,7.09,0,0,1,1.23.62,5.9,5.9,0,0,1,.92.73c.41,2.12.81,4.24,1.33,6.34a21.09,21.09,0,0,0,1.31,3.88,11.39,11.39,0,0,0,3.07,4C39.72,425.47,39.75,424.72,39.59,424.51Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59,424.51a20,20,0,0,1-3.07-7.11c-.54-2.15-.94-4.33-1.35-6.51a6.72,6.72,0,0,1,.34-1.39q.29-.75.63-1.47l.37-.71a3.28,3.28,0,0,0,.3-1.1s0-.12-.07-.1c-.61.2-.91.82-1.23,1.33a9.41,9.41,0,0,0-.73,1.41c-.48-2.47-1-4.95-1.47-7.42h0c.09-.41.16-.82.28-1.21.25-.79.65-1.51,1-2.27a11.17,11.17,0,0,0,.76-2.51A7,7,0,0,0,35.5,393c0-.22-.23,0-.21.15.14.9-.6,1.74-1,2.49s-.73,1.37-1.08,2.07c-.16.32-.32.65-.47,1a23.83,23.83,0,0,0-2-6.83,11.58,11.58,0,0,0-2.57-3.25,12.76,12.76,0,0,0-2-1.37,17.83,17.83,0,0,0-2.45-1c-.08,0-.13.17-.06.21.62.4,1.19.88,1.81,1.27a18,18,0,0,1,1.94,1.4,7.34,7.34,0,0,1,2.17,3,38.44,38.44,0,0,1,1.8,7.25,18.58,18.58,0,0,0-3.54-.6,10.91,10.91,0,0,1-3.67-1.06c-.16-.08-.23.27-.12.35a8.62,8.62,0,0,0,3.73,1.48c.67.13,1.34.26,2,.41s1.2.33,1.8.5c.54,2.85,1.11,5.68,1.67,8.52l.18.94a5.92,5.92,0,0,0-.48-.35,5.47,5.47,0,0,0-1.39-.69,2.54,2.54,0,0,0-.77-.18c-.24,0-.48,0-.72,0s-.19.35,0,.39a8,8,0,0,1,1.41.47,7.09,7.09,0,0,1,1.23.62,5.9,5.9,0,0,1,.92.73c.41,2.12.81,4.24,1.33,6.34a21.09,21.09,0,0,0,1.31,3.88,11.39,11.39,0,0,0,3.07,4C39.72,425.47,39.75,424.72,39.59,424.51Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,341.38a69,69,0,0,0-7.13,3.48c-.44.24-.93.5-1.42.79l.12-.2a71.59,71.59,0,0,0,5.62-11.08q1.11-2.94,1.93-6c.56-2.08.84-4.2,1.2-6.33,0-.25-.24-.43-.31-.12-.45,1.93-1.14,3.8-1.75,5.68s-1.29,3.66-2,5.44a82.42,82.42,0,0,1-5.1,10.05c-.26.43-.52.86-.77,1.29v-.85a19,19,0,0,0-.32-3.53,21.56,21.56,0,0,0-.88-3.24,7.27,7.27,0,0,0-1.51-3c-.12-.11-.21.09-.2.19a22.68,22.68,0,0,0,1.08,2.95,19.25,19.25,0,0,1,.72,3.18,21.91,21.91,0,0,1,.16,3.24,22.84,22.84,0,0,0-.15,2.86c-1.39,2.29-2.77,4.6-4,7-.57,1.08-1.1,2.17-1.62,3.28l0-.15A21.57,21.57,0,0,0,57,352.67c-1.23-2.71-2.65-5.36-3.11-8.34,0-.15-.16,0-.16.07a23.5,23.5,0,0,0,1.85,7.45c.48,1.3.91,2.6,1.26,3.93a13.18,13.18,0,0,1,.38,2c0,.34.06.66.12,1-.06.13-.12.27-.17.4a3.55,3.55,0,0,0-.51,1.18c-.35.85-.7,1.69-1,2.55-1.2,3.09-2.25,6.25-3.16,9.44a19.8,19.8,0,0,0-.94-3.48,20.22,20.22,0,0,0-1.57-3.37,11.5,11.5,0,0,0-2.25-3.16c-.12-.09-.16.2-.14.26.49,1.09,1.22,2.05,1.69,3.15a34.23,34.23,0,0,1,1.23,3.24,50.41,50.41,0,0,1,1.3,5.82,126,126,0,0,0-2.65,13.07c-.68-1.69-1.57-3.28-2.41-4.92-.11-.21-.28.12-.22.26a33.52,33.52,0,0,1,2,6.18c.09.43.16.86.23,1.29-.6,4.69-1,9.42-1.11,14.14,0,.7.07,5,.16,7.67a43.44,43.44,0,0,0,.61,6.62,18.45,18.45,0,0,0,1,3.44c.23.5.78,1,1.28.77-.12-.83-.16-1.67-.34-2.48a59.52,59.52,0,0,1-1-11.06c0-1.19,0-2.38,0-3.57.08-3.68.31-7.36.67-11a13.33,13.33,0,0,1,1.47-2.89c1.69-2.43,4.28-4,6-6.39.1-.13.06-.65-.2-.5a28.84,28.84,0,0,0-4,3,15.37,15.37,0,0,0-2.92,3c.27-2.14.58-4.28,1-6.41q.63-3.56,1.47-7.06a11,11,0,0,0,.88-1.06c.38-.5.75-1,1.17-1.5A12.17,12.17,0,0,1,57.67,373a11.44,11.44,0,0,1,3-1.33c.5-.14,1-.27,1.52-.36a5.1,5.1,0,0,0,1.6-.36c.07,0,.1-.22,0-.26-1.08-.56-2.71-.27-3.84,0a12,12,0,0,0-3.56,1.44,11.61,11.61,0,0,0-2.67,2.27c.89-3.3,1.92-6.56,3.12-9.76.71-1.9,1.49-3.77,2.31-5.61a8.88,8.88,0,0,1,2.13-1.23,30.14,30.14,0,0,1,3.22-1,20.13,20.13,0,0,0,3-1.21c.12-.06.15-.4,0-.36-1.25.34-2.59.44-3.86.69a17.24,17.24,0,0,0-3.46,1c1.24-2.6,2.58-5.15,4-7.66a13.52,13.52,0,0,1,1.55-1.83,19.65,19.65,0,0,1,3-1.79,70.84,70.84,0,0,0,6.19-3.76C75,341.71,74.94,341.3,74.74,341.38Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,341.38a69,69,0,0,0-7.13,3.48c-.44.24-.93.5-1.42.79l.12-.2a71.59,71.59,0,0,0,5.62-11.08q1.11-2.94,1.93-6c.56-2.08.84-4.2,1.2-6.33,0-.25-.24-.43-.31-.12-.45,1.93-1.14,3.8-1.75,5.68s-1.29,3.66-2,5.44a82.42,82.42,0,0,1-5.1,10.05c-.26.43-.52.86-.77,1.29v-.85a19,19,0,0,0-.32-3.53,21.56,21.56,0,0,0-.88-3.24,7.27,7.27,0,0,0-1.51-3c-.12-.11-.21.09-.2.19a22.68,22.68,0,0,0,1.08,2.95,19.25,19.25,0,0,1,.72,3.18,21.91,21.91,0,0,1,.16,3.24,22.84,22.84,0,0,0-.15,2.86c-1.39,2.29-2.77,4.6-4,7-.57,1.08-1.1,2.17-1.62,3.28l0-.15A21.57,21.57,0,0,0,57,352.67c-1.23-2.71-2.65-5.36-3.11-8.34,0-.15-.16,0-.16.07a23.5,23.5,0,0,0,1.85,7.45c.48,1.3.91,2.6,1.26,3.93a13.18,13.18,0,0,1,.38,2c0,.34.06.66.12,1-.06.13-.12.27-.17.4a3.55,3.55,0,0,0-.51,1.18c-.35.85-.7,1.69-1,2.55-1.2,3.09-2.25,6.25-3.16,9.44a19.8,19.8,0,0,0-.94-3.48,20.22,20.22,0,0,0-1.57-3.37,11.5,11.5,0,0,0-2.25-3.16c-.12-.09-.16.2-.14.26.49,1.09,1.22,2.05,1.69,3.15a34.23,34.23,0,0,1,1.23,3.24,50.41,50.41,0,0,1,1.3,5.82,126,126,0,0,0-2.65,13.07c-.68-1.69-1.57-3.28-2.41-4.92-.11-.21-.28.12-.22.26a33.52,33.52,0,0,1,2,6.18c.09.43.16.86.23,1.29-.6,4.69-1,9.42-1.11,14.14,0,.7.07,5,.16,7.67a43.44,43.44,0,0,0,.61,6.62,18.45,18.45,0,0,0,1,3.44c.23.5.78,1,1.28.77-.12-.83-.16-1.67-.34-2.48a59.52,59.52,0,0,1-1-11.06c0-1.19,0-2.38,0-3.57.08-3.68.31-7.36.67-11a13.33,13.33,0,0,1,1.47-2.89c1.69-2.43,4.28-4,6-6.39.1-.13.06-.65-.2-.5a28.84,28.84,0,0,0-4,3,15.37,15.37,0,0,0-2.92,3c.27-2.14.58-4.28,1-6.41q.63-3.56,1.47-7.06a11,11,0,0,0,.88-1.06c.38-.5.75-1,1.17-1.5A12.17,12.17,0,0,1,57.67,373a11.44,11.44,0,0,1,3-1.33c.5-.14,1-.27,1.52-.36a5.1,5.1,0,0,0,1.6-.36c.07,0,.1-.22,0-.26-1.08-.56-2.71-.27-3.84,0a12,12,0,0,0-3.56,1.44,11.61,11.61,0,0,0-2.67,2.27c.89-3.3,1.92-6.56,3.12-9.76.71-1.9,1.49-3.77,2.31-5.61a8.88,8.88,0,0,1,2.13-1.23,30.14,30.14,0,0,1,3.22-1,20.13,20.13,0,0,0,3-1.21c.12-.06.15-.4,0-.36-1.25.34-2.59.44-3.86.69a17.24,17.24,0,0,0-3.46,1c1.24-2.6,2.58-5.15,4-7.66a13.52,13.52,0,0,1,1.55-1.83,19.65,19.65,0,0,1,3-1.79,70.84,70.84,0,0,0,6.19-3.76C75,341.71,74.94,341.3,74.74,341.38Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,397.06a7.26,7.26,0,0,0-3.84.08,18.38,18.38,0,0,0-4,1.19,9.72,9.72,0,0,0-2.24,1.38,24,24,0,0,1,3.54-5.61,28,28,0,0,1,5.66-5.36c.08-.05.09-.35,0-.29A20.86,20.86,0,0,0,61,392.17a21.74,21.74,0,0,0-4.26,5.68,24.27,24.27,0,0,0-1.33,3l-.18-.6a12.09,12.09,0,0,0-.83-1.79,6.77,6.77,0,0,0-.57-.83c-.13-.16-.3-.46-.55-.42,0,0-.07.07-.06.12a2.2,2.2,0,0,0,.36.89c.12.24.26.48.38.73a16.09,16.09,0,0,1,.61,1.55c.18.55.27,1.11.4,1.68-.21.73-.4,1.47-.54,2.22a29.21,29.21,0,0,0-.48,4.37q-.18-.47-.39-.93A12.44,12.44,0,0,0,52,405.5c-.12-.14-.23.18-.15.29a12.35,12.35,0,0,1,1.83,4.89c0,.3.11.6.16.9,0,.5,0,1,0,1.49,0,1.8.05,3.6,0,5.4s-.25,3.44-.32,5.16c0,.26.42.8.62.39,1.24-2.47,1.23-5.5,1.26-8.21,0-1.67,0-3.35,0-5l.06-.05a3.84,3.84,0,0,1,.9-.41,13.21,13.21,0,0,0,5.12-3.3c.06-.07,0-.31-.08-.2a7.29,7.29,0,0,1-3.57,1.94c-.7.19-1.39.4-2.09.6l-.32.11c0-.77.07-1.55.14-2.32a23.25,23.25,0,0,1,.74-4c.54-.57,1-1.31,1.52-1.87a9.91,9.91,0,0,1,2.61-1.83,17.12,17.12,0,0,1,3.33-1.25l1.8-.48a5.24,5.24,0,0,1,2.06-.39C67.77,397.34,67.8,397.1,67.69,397.06Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,397.06a7.26,7.26,0,0,0-3.84.08,18.38,18.38,0,0,0-4,1.19,9.72,9.72,0,0,0-2.24,1.38,24,24,0,0,1,3.54-5.61,28,28,0,0,1,5.66-5.36c.08-.05.09-.35,0-.29A20.86,20.86,0,0,0,61,392.17a21.74,21.74,0,0,0-4.26,5.68,24.27,24.27,0,0,0-1.33,3l-.18-.6a12.09,12.09,0,0,0-.83-1.79,6.77,6.77,0,0,0-.57-.83c-.13-.16-.3-.46-.55-.42,0,0-.07.07-.06.12a2.2,2.2,0,0,0,.36.89c.12.24.26.48.38.73a16.09,16.09,0,0,1,.61,1.55c.18.55.27,1.11.4,1.68-.21.73-.4,1.47-.54,2.22a29.21,29.21,0,0,0-.48,4.37q-.18-.47-.39-.93A12.44,12.44,0,0,0,52,405.5c-.12-.14-.23.18-.15.29a12.35,12.35,0,0,1,1.83,4.89c0,.3.11.6.16.9,0,.5,0,1,0,1.49,0,1.8.05,3.6,0,5.4s-.25,3.44-.32,5.16c0,.26.42.8.62.39,1.24-2.47,1.23-5.5,1.26-8.21,0-1.67,0-3.35,0-5l.06-.05a3.84,3.84,0,0,1,.9-.41,13.21,13.21,0,0,0,5.12-3.3c.06-.07,0-.31-.08-.2a7.29,7.29,0,0,1-3.57,1.94c-.7.19-1.39.4-2.09.6l-.32.11c0-.77.07-1.55.14-2.32a23.25,23.25,0,0,1,.74-4c.54-.57,1-1.31,1.52-1.87a9.91,9.91,0,0,1,2.61-1.83,17.12,17.12,0,0,1,3.33-1.25l1.8-.48a5.24,5.24,0,0,1,2.06-.39C67.77,397.34,67.8,397.1,67.69,397.06Z",
    style: {
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.57,407.07c-1.05-14.46.57-25.54-.63-48.11h0c-.11-5.79-.32-12-.7-17.49-1.31-18.53-4.17-24.86-4.43-28.44,0,0-.49-28.82-1.7-69.36-.57-19.07-6.1-24.85-10.51-35H377.11c-5.86,25-7.53,79.45-7.35,105.19.09,13.12,5.38,83.33,5.49,84.95.37,5.73-.13,8-2.37,10.4-4.7,5-11.52,9.84-17.41,14.24.85,2.26,7.94,2.17,11.45.46A89.71,89.71,0,0,0,380,415.6c4.84-3.58,11-6.46,11.1-11.91a5.59,5.59,0,0,1,.17-1c.09-3.18,7.51-50.15,8.13-61,.53-9.37-.61-25.28-.61-25.28l6-39.69s3.72,23.46,7.49,39.48c3.07,13,8.13,35.29,11.59,51.34h0c3.32,18.49,8.19,31.64,9,40.9.26,2.21,2.76,23.89,3.79,28.86s11.86,5.1,12.56-3.44C449.76,428.15,447.77,409.79,447.57,407.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.44,429.25c-.3,0-.79,3.29.83,4.71,1.86,1.64,7.34,4.36,14.64,3.5s11.27-3.08,14.21-5.49,7.06-5.8,10.37-6.5c3.07-.64,6.41-2,7.4-2.93s.9-5.14.9-5.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.42,401.17s.55,0,.73,1c.21,1.16.41,4.54.88,6.45.64,2.65,1,8.07.6,10.23s-5.43,3.59-8.63,4.77A40.89,40.89,0,0,0,374.59,430c-3.45,2.78-10.68,5.54-15.43,5.56-7.25,0-11.93-2-13.35-4.61-1.76-3.24-.33-5.1,8-8.87,1.58-.71,7.16-3.93,9.06-5.1a42.39,42.39,0,0,0,5.72-4.16,31.77,31.77,0,0,0,2.57-2.49,11.13,11.13,0,0,0,2.13-2.67c.1-.22.17-.48.26-.7a12.35,12.35,0,0,0,.56-1.95c.14-.69.24-1.7.9-2.11a5.58,5.58,0,0,1,3-.32,21.63,21.63,0,0,1,3.21.49c1.22.29,2.64.41,3.36,1.57a6.19,6.19,0,0,1,.65,3c0,.48,0,1,0,1.46,0,.21-.09.58.2.5s.59-.8.7-1.05c.24-.54.39-1.12.65-1.66a8.87,8.87,0,0,1,1.06-1.75,8.37,8.37,0,0,1,1.33-1.33,15.21,15.21,0,0,0,1.44-.91A3.38,3.38,0,0,0,391.42,401.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,422.74c10.49.84,13.72,7.36,14.13,11.37a24.64,24.64,0,0,1-7.47,1.49c-7.25,0-12.23-2-13.65-4.61C343.85,427.93,345,425.49,352.5,422.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.23,423a.57.57,0,0,0,.33-.11.51.51,0,0,0,.08-.72,12.33,12.33,0,0,0-9.45-3.85.51.51,0,0,0-.46.56.5.5,0,0,0,.56.46,11.46,11.46,0,0,1,8.55,3.47A.51.51,0,0,0,368.23,423Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,420.43a.51.51,0,0,0,.33-.11.52.52,0,0,0,.08-.72,12.29,12.29,0,0,0-9.45-3.84.51.51,0,0,0,.1,1,11.42,11.42,0,0,1,8.55,3.46A.48.48,0,0,0,372.78,420.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,417.47a.51.51,0,0,0,.33-.11.52.52,0,0,0,.08-.72,12.37,12.37,0,0,0-9.45-3.85.51.51,0,0,0-.46.56.5.5,0,0,0,.56.46,11.46,11.46,0,0,1,8.55,3.47A.51.51,0,0,0,377,417.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,414.51a.56.56,0,0,0,.32-.11.52.52,0,0,0,.09-.72c-2-2.56-6.51-4.28-10.32-3.91a.52.52,0,0,0-.47.56.52.52,0,0,0,.56.46c3.44-.33,7.66,1.25,9.42,3.52A.54.54,0,0,0,381.14,414.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.34,441.15c.29,5,1.06,8.24,2.82,11.14s5.07,3.81,8.42,3,7.66-3.12,8.62-7.39,1.52-7.2.76-11.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.45,405.3c1.38.11,1.79,6.76,2.59,13.41.85,7.14,3,10.09,3.75,15.94.87,6.68-.24,9.67-2.58,13.71s-10.63,8-14.71,2.22c-3.33-4.72-3.47-9.95-3.17-16.63a147.68,147.68,0,0,0-.44-16.91c-.27-5-1.38-10.05-.18-10.6.09.73.18,1.66.28,2.38a12,12,0,0,0,.45,2.67c.14.37.45.77.57.16a3.69,3.69,0,0,0,0-1.24c-.2-1.85.73-2,1.23-2.14a61,61,0,0,1,6.41-.91c1.06-.07,4.71-.23,5.18.37a4.15,4.15,0,0,1,.47,1.93c.11,1,.35,1.75.38,1.43.06-.72-.08-2.59-.1-3s-.08-1-.09-1.46S447.48,405.73,447.45,405.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.17,438.52a16.7,16.7,0,0,1-2.58,10.16c-2.35,4-11.3,8-15.39,2.23-2-2.88-2.58-6.29-2.86-9.76C435.79,436.69,450.31,434.72,454.17,438.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.36,433.88a.47.47,0,0,0,.17,0c.06,0,6.46-2.68,12.68-1.23a.53.53,0,0,0,.62-.39.52.52,0,0,0-.39-.62c-6.58-1.52-13.11,1.2-13.35,1.31a.51.51,0,0,0,.27,1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.9,427.62a.51.51,0,0,0,.12-1c-6.2-2.1-13.08,1.05-13.34,1.19a.51.51,0,0,0-.22.69.52.52,0,0,0,.7.21s6.76-3.08,12.53-1.12A.5.5,0,0,0,448.9,427.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.69,422.93a.52.52,0,0,0,.43-.34.53.53,0,0,0-.31-.66c-6.82-2.44-13.35,1-13.59,1.15a.51.51,0,1,0,.53.88c.05,0,6.36-3.33,12.71-1.06A.61.61,0,0,0,448.69,422.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.35,418.3a.51.51,0,0,0,.13-1c-6.39-2.39-13.42,1.14-13.69,1.3a.52.52,0,0,0-.19.7.51.51,0,0,0,.7.18c.07,0,6.88-3.44,12.82-1.22A.45.45,0,0,0,448.35,418.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,208.87c6.22,11.34,10.84,20.61,11.46,54.32s.53,43.16.66,47.22,2.5,11.34,4.58,31.36-.38,43.89-.38,43.89-1.43,3.22-9.09,3.91c-7.07.63-10.56-2-10.56-2s-9.69-39-12.37-51.06-10.46-51.72-10.46-51.72l-4.62,32.16s2.15,11.06,0,28.62-6,35.55-6,35.55a32,32,0,0,1-10.85,1.77,18.28,18.28,0,0,1-9.52-2.49s-6-52.25-6-72.15,1.68-69.67,7.94-99.14Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,208.87c6.22,11.34,10.84,20.61,11.46,54.32s.53,43.16.66,47.22,2.5,11.34,4.58,31.36-.38,43.89-.38,43.89-1.43,3.22-9.09,3.91c-7.07.63-10.56-2-10.56-2s-9.69-39-12.37-51.06-10.46-51.72-10.46-51.72l-4.62,32.16s2.15,11.06,0,28.62-6,35.55-6,35.55a32,32,0,0,1-10.85,1.77,18.28,18.28,0,0,1-9.52-2.49s-6-52.25-6-72.15,1.68-69.67,7.94-99.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.26,314s-3.88-4.05-11.35-3.15-10.51,5.29-10.51,5.29C421.4,312.53,435.26,314,435.26,314Zm-17.58,3.58c4.4.88,8.79,1.27,18.42-.64C431.53,315.82,417.68,317.57,417.68,317.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,314.06c-2.75-1.58-13-3.66-19.42-2.8l.07,2.16A94.4,94.4,0,0,1,387.35,314.06Zm-19.24,2.16.11,2s10.26-.52,14.56-1.68C375.45,316,368.11,316.22,368.11,316.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.36,326c-.25-1.16-.49-2.26-.71-3.3-1.95-9.32-1.93-21.5-1.89-36.92,0-4.66,0-9.48,0-14.6-.18-20.08-1.72-42.57-11.88-57.07l-.82.58c6.83,9.75,9.7,23.24,10.9,37.16-10.08-1.34-12.29-11.3-15.3-25-.41-1.87-.83-3.81-1.29-5.8l-1,.23c.46,2,.89,3.92,1.3,5.79,3,13.68,5.38,24.51,16.35,25.82.49,6.13.67,12.33.72,18.31,0,5.12,0,9.93,0,14.59,0,15.48-.06,27.71,1.91,37.12.22,1.05.46,2.15.71,3.31,2.61,12,6.52,30.11,4.57,61.58a8,8,0,0,0,1.05-.67C447.85,355.94,444,338,441.36,326ZM377.82,237.8c1.41,6.63,12,12.21,16.78,13.36l1.22,6.74c-.24,3.58-.5,7.34-.76,11.23-1.46,21.41-3,43.55-1.88,48.55,2.88,13.15,2,21.49.48,36.63-.16,1.54-.32,3.16-.49,4.86-.88,8.79-1.85,17.41-2.49,22.94l1-.24c.64-5.54,1.59-14,2.44-22.6.17-1.7.34-3.32.5-4.86,1.56-15.24,2.41-23.64-.51-37-1.06-4.85.52-27.91,1.91-48.26.16-2.47.33-4.89.49-7.24l4.28,23.73-.61,31.24,4.62-32.16-6.31-38.28S385.22,245.54,377.82,237.8Z",
    style: {
      fill: "#28A745",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.67,119.4s2.57,15.56,4.17,19.19,4.5,6.6,1.53,6.63a3.68,3.68,0,0,1-3.65-2.71l.64,12.37L390,157.08V119.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.47,151.08c-8,1.92-12,3-17,10.47-5.07,7.64-10.2,16.15-17.83,27.85l-20-9.33-8,13.92s20.46,11.71,29.44,15.84c5.69,2.63,9.88.75,14.27-3.84,4.89-5.1,16.71-22.46,16.71-22.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,189.4c3.38,1.15,7,4.36,7.59,6.28-1.94-5.9-5-7-6.62-7.76Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.74,234.06c-1.32-9.85-6.63-28.64-6.93-30.91-1.78-13.2.57-19.9,1.43-25.68,1.88-12.58-1.72-23.12-4.65-25.6,0,0-3.33-.82-6.12-1.32-2.21-.4-3.92-.66-6.84-1.37-7.26-1.76-15.2,0-18,.25a29.42,29.42,0,0,0-5.67.41c-2,.45-6.51,1.24-6.52,1.24a41.33,41.33,0,0,0-8.65,11.12c-3.19,5.7-5.39,10.13-5.88,21.41-.82,18.76-.77,42.46-1.35,53.1,10.38,6.39,43.11,10.52,58.83,3.19l-.08-15.63L434,238.59A20.63,20.63,0,0,0,440.74,234.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.79,176c-.43,2.87-.71,5.75-1,8.64-.52,5.78-.79,11.57-1,17.36s-.28,11.59-.23,17.38c0,2.9.06,5.79.14,8.69s.2,5.79.36,8.68l.27-17.36c.11-5.79.23-11.58.46-17.36s.44-11.56.8-17.33c.18-2.88.39-5.77.71-8.64a48.34,48.34,0,0,1,1.42-8.54A43.73,43.73,0,0,0,395.79,176Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tablet--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308,164h0l1.55-1.45v0a1.85,1.85,0,0,1,1.65-.25l47.91,11.09a6.4,6.4,0,0,1,4.06,3.5l14,35.69a1.63,1.63,0,0,1-.16,1.86h0l-1.6,1.5v0a1.85,1.85,0,0,1-1.67.26l-47.91-11.09a6.4,6.4,0,0,1-4.06-3.5l-14-35.69C307.42,165,307.54,164.32,308,164Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,164h0l1.55-1.45v0a1.85,1.85,0,0,1,1.65-.25l47.91,11.09a6.4,6.4,0,0,1,4.06,3.5l14,35.69a1.63,1.63,0,0,1-.16,1.86h0l-1.6,1.5v0a1.85,1.85,0,0,1-1.67.26l-47.91-11.09a6.4,6.4,0,0,1-4.06-3.5l-14-35.69C307.42,165,307.54,164.32,308,164Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.46,175.75a6.27,6.27,0,0,1,2.13,2.58l14,35.68a1.74,1.74,0,0,1-.1,1.82l1.51-1.4,0,0a1.63,1.63,0,0,0,.16-1.85l-14-35.69a6.25,6.25,0,0,0-2-2.45Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,214l-14-35.68a6.47,6.47,0,0,0-4.07-3.51l-47.91-11.08c-1.63-.38-2.46.58-1.85,2.14l14,35.69a6.4,6.4,0,0,0,4.06,3.5l47.91,11.09C375.36,216.53,376.19,215.57,375.57,214Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,214l-14-35.68a6.47,6.47,0,0,0-4.07-3.51l-47.91-11.08c-1.63-.38-2.46.58-1.85,2.14l14,35.69a6.4,6.4,0,0,0,4.06,3.5l47.91,11.09C375.36,216.53,376.19,215.57,375.57,214Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,185.92l-2.62-6.68a1.24,1.24,0,0,0-.76-.66l-3.3-.75c-.3-.07-.46.11-.35.4.52,1.31,2.11,5.36,2.62,6.68a1.23,1.23,0,0,0,.76.65l3.3.76C361.83,186.39,362,186.21,361.87,185.92Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,180.86a3,3,0,0,0-1.93-1.61c-.79-.18-1.21.25-.93,1a3,3,0,0,0,1.94,1.61C359,182,359.43,181.57,359.15,180.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43,184.24a3,3,0,0,0-1.93-1.62c-.79-.18-1.21.25-.93,1a3,3,0,0,0,1.94,1.61C360.3,185.38,360.71,185,360.43,184.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.86,187.45c-1.82-2-1.71-2.35-1-3.57a7,7,0,0,1,5.34-3.52c1.95-.16,3.91-.41,5,0s.43,2.61-2,3.45c-3.89,1.33-3.74,2.41-3.74,2.41a49.56,49.56,0,0,1,5.05-1.46c1.46-.25,4.23.16,5.94.24s2.29,2.22-.48,3.28l3.13.15c2.2.11,3.06,1.18,1.51,2.7a3.23,3.23,0,0,1-1.87,1s2.29-.26,2.43.5c.37,2.18-1,2.91-5.48,4.77-4.29,1.77-4.94,4.25-3.88,5.8,0,0-1.9-.84-3.61-1.77-1.25-.67-2.34-1.47-2-3.34,0,0-2.53.32-2.85-1.22a8.12,8.12,0,0,1,.24-3.43,2.78,2.78,0,0,1-1.68-2.44,4.55,4.55,0,0,1,.62-2.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,188.28a14.18,14.18,0,0,0-2.84,0,9,9,0,0,0-2.61,1.16,32.49,32.49,0,0,0-4.6,3.14,32.54,32.54,0,0,0,5-2.43,14.67,14.67,0,0,1,2.37-1.25C325.07,188.67,326,188.55,326.93,188.28Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,192.08a6.16,6.16,0,0,0-3,.24,15.82,15.82,0,0,0-2.79,1.22,28.48,28.48,0,0,0-5,3.4,58,58,0,0,0,5.35-2.67A15.81,15.81,0,0,1,329.7,192.08Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.74,178.74c-3.62-2.7-5.45-3.75-7.14-4.23s-7.61-2.94-9.88-3.51c-1.44-.35-2,1.94-.19,3.51,1.41,1.22,5.08,2.81,6.7,3.69s4.77,4.73,4.77,4.73Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.64,161.12c-3.59-7.65-4.92-7.27-13.61-8.28-6.22,7.32-3.28,24.69-3.28,24.69L433.13,199s-21.65-5.82-24.1-7.39-9-8.63-11.23-10.75c-3-2.88-4.49-2.49-6-2.26-5,.75-6.09,1.17-7.14,1.84a2.26,2.26,0,0,0-1,1.94c-1.32.17-3.31.13-3.56,2.31a6,6,0,0,0-.08,1.74,1.43,1.43,0,0,0-.86.5c-1.11,1.28.78,5.7,2,6.78.84.76,2.05.85,3.63.64,1.34-.18.71-1.55.71-1.55l1.88.11c4.07,2.88,4.27,8.6,9.64,9.86a37,37,0,0,1,6.56,1.28c11.56,3.88,30.52,15.65,40.82,16.54,10.06.86,9.77-4.5,9.92-10.65C454.45,204.45,449.22,168.75,445.64,161.12Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,196.91l.43,2.1c4.58,1.18,9.53,4.48,10.62,7C442.9,202,440.76,199.06,432.7,196.91Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.59,151.87c6.33.77,10.47.69,13.16,4.57s3.3,5,5.26,14.53,5.49,30.34,5,34c-4.09-4.09-20.84-6-20.84-6l-.43-.11s-2.35-11.24-3.43-15S425.19,161.21,430.59,151.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9,195.13c-.62.31-.81.79-.57,1.78a7.43,7.43,0,0,1,.23,1.68s-.34-.05,1.57.42,11.64,4.87,15.4,9.45a25.84,25.84,0,0,1,4.89,8.75,5,5,0,0,1-1.44,2c1,0,2.13-.78,3.11-3.34.44-1.16-.53-2.46.29-5.11a9.22,9.22,0,0,0-.14-6.41c-.7-1.95,2-3.77-1.68-6S439.79,193.08,431.9,195.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.66,182.39l5.94-1.19-5.81.37A2.38,2.38,0,0,0,383.66,182.39Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,186.44l6.82-.88-6.83.09A3.5,3.5,0,0,0,380,186.44Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,189.45a2.17,2.17,0,0,0,.92.8,4.69,4.69,0,0,0,1.16.4l-.09-.07c.19.36.38.71.58,1.06l.14-.19a1.39,1.39,0,0,0-1.09.27,1.82,1.82,0,0,0-.59.89,2.14,2.14,0,0,1,.69-.74,1.41,1.41,0,0,1,.93-.17l.26.05-.12-.23c-.18-.36-.37-.71-.57-1.06l0-.06h-.06a6.4,6.4,0,0,1-1.14-.31A2.54,2.54,0,0,1,380.92,189.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,190.33a21,21,0,0,0,2.47.17,2.75,2.75,0,0,0,.85,1.31,13.61,13.61,0,0,0,1.32,1.11l-1.88-.11a3,3,0,0,0-2.15-1.16Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408,93.55c-1.15-2.91,1.12-5.21,3.05-4.54a3.09,3.09,0,0,1,1.37-3.79c2-1.16,4.3.39,4.3.39a3.76,3.76,0,0,1,3-3c2.51-.39,3.79.37,4.88,1.94,0,0,4-1,9.59,3.25,3.26,2.46,4.48,4.36,3.95,6.9-.36,1.75-2.57,1.79-2.57,1.79s2.77,1.56,1.82,4.33-3.25,1.55-3.25,1.55a3,3,0,0,1,.39,3.77,3.27,3.27,0,0,1-3.33,1.25c.46.06.51,4.65-3.79,3.34C423.55,110.64,408,93.55,408,93.55Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.72,110.85a1.82,1.82,0,0,0-.14-2.21,3.44,3.44,0,0,0-.93-4.77s0-5-4.18-3.9l1.8,7.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,84.58a14.34,14.34,0,0,1,7.5-2.71c4.33-.2,5.06,1.27,4.38,2.1s-4.07.52-6.91,3.18S424.59,84.58,424.59,84.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,85.2a8.57,8.57,0,0,1,1.44-5.62c1.88-2.7,3.58-1.14,3,.77a14.84,14.84,0,0,0-.35,4.43Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.56,96.52s-4.68-6.16-10-7.49a13.54,13.54,0,0,1,7,3.07C435.37,94.73,435.56,96.52,435.56,96.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.31,84.24a4.19,4.19,0,0,0-.57,1.37c.59,2.63,4.52,6.91,7.28,8.39C424,94,418.22,88.76,417.31,84.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.23,123.38s6.41,1.21,8.48-.32c3.41-2.5,3.28-4.61,3.19-5.68a3,3,0,0,0-1.17-2.35,3.61,3.61,0,0,0,1.36-3.56c-.46-2.29-2-2.24-2-2.24s1.63-3-1.07-4c0,0,1.19-2.14.06-3.81a4,4,0,0,0-2.74-1.81,3.8,3.8,0,0,0-1-3.27,3.16,3.16,0,0,0-4.08-.37,3,3,0,0,0-1.18-3.51,3.69,3.69,0,0,0-4-.35,3.88,3.88,0,0,0-3.11-2.8,3.34,3.34,0,0,0-3.56,2.19,4.55,4.55,0,0,0-4.5-2.16,4.41,4.41,0,0,0-3.67,2.46,5.08,5.08,0,0,0-4.45-.71c-2.73,1-2.88,3-2.88,3a3.6,3.6,0,0,0-3.68.6,3.13,3.13,0,0,0-1.34,3.24,3.15,3.15,0,0,0-2.25,1.87,3.61,3.61,0,0,0,.21,3.29s-2.78,2.73-.63,5.65c1.49,2,6.29,12.45,16.14,16.39A19.82,19.82,0,0,0,417.23,123.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,100.61c-2.83-.18-4.47,4-5.16,8.81s-4.1,8.1-2.55,9.39,3.64-1.08,5-3.49,2.41-9.21,4-10.23S384.52,100.61,384.52,100.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.16,105.89a16.41,16.41,0,0,0-1.83,9,25.8,25.8,0,0,1-.15,6.21c-1.47,8.51.9,17.24,6.63,20a18.49,18.49,0,0,0,9.2,1.7l.07,3.42a3,3,0,0,1-2.16,3l-3.29.8a29.6,29.6,0,0,0,4.06,17.53c8.54-1.72,23.91-12.95,27.24-16.8h0a6.39,6.39,0,0,1-7.05-6.53l.3-10.91s2.32,2.49,6.63-.91c3.57-2.8,5-7.77,2.46-10.61a6.15,6.15,0,0,0-9.76,1.36s-5.81.45-4.61-4.29l-.06-.4,0-.25c-2.16-.75-2.42-4.65-.67-4.65-.07-.39-.05-.3-.12-.69-2.35-.42-3.11-5-1-4.76a11.44,11.44,0,0,0-3.81-5.24l-.68.27c-.48,2.62-4.33,2.93-5.17,1.87-.5.13-1.37-1.62-1.86-1.5-.81,2.39-5.17,1.26-6.29-.19C392.44,104.44,389.58,105.66,385.16,105.89Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,142.78c9.61-1.22,13-6.6,14.56-10.07,0,0-.19,5.41-3.8,8.46a18.12,18.12,0,0,1-10.71,4.51Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.76,130.25l-5.85,1.94a3,3,0,0,0,3.84,2.06A3.22,3.22,0,0,0,402.76,130.25Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4,131.61a3.4,3.4,0,0,0-3.36,2.68,2.94,2.94,0,0,0,1.71,0,3.17,3.17,0,0,0,2.11-2.59A3.41,3.41,0,0,0,402.4,131.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,115.19l4.32-2a2.28,2.28,0,0,0-3.07-1.23A2.49,2.49,0,0,0,385.66,115.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48,115.76l-4.23-2.26a2.29,2.29,0,0,1,3.17-1A2.53,2.53,0,0,1,406.48,115.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.26 116.41 395.75 128.88 389.32 126.31 396.26 116.41",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,118.67a2,2,0,0,1-1.8,2.18,1.91,1.91,0,0,1-2.14-1.73,2,2,0,0,1,1.8-2.17A1.92,1.92,0,0,1,390.81,118.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,118.86a2,2,0,0,1-1.79,2.17,1.9,1.9,0,0,1-2.14-1.72,2,2,0,0,1,1.8-2.17A1.89,1.89,0,0,1,405.12,118.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.43,103.36c-.79-4-2.24-7.56-9.17-11.61,0,0,8.11,4.19,8.28,12.46Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,94.07a14.5,14.5,0,0,1,10.63,11.59l-2.1-1.29C399.59,102.53,398.09,96.84,390.93,94.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.91,97.91a7,7,0,0,1,7.34,5.68l-.81.62S392.12,99.69,385.91,97.91Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,107.22s8.36,1.63,14.75-1.56c0,0-3.9,3.2-14.62,2.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,112.68s7.94,1.19,14.8-2.6c0,0-3.65,3.49-14.4,3.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,118.05s8.35,1.06,14.85-2.68c0,0-3.65,3.49-14.41,3.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,167.48s9.38-5.93,13-9.06c6.76-5.89,7.53-10.39,7.53-10.39s-.08-1.2-.27-2.78c.92.12,1.08.84,2.12,2.14a11.37,11.37,0,0,0,5.15,3.26s-.28,3.64-5.36,10.49c-4.07,5.48-13.82,11.05-15.06,11.36S397.69,167.48,397.69,167.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,167.48c-3.43-6.37-1.73-12.68-1.11-14.71s1.11-3.82,1.11-3.82a3.18,3.18,0,0,0,1.39-2.75l0-.83a5.85,5.85,0,0,0-2.27,1.66,11.56,11.56,0,0,1-6.08,3.47c-3,6.13-3.2,13.85-.55,19C390.58,170.26,397.69,167.48,397.69,167.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.38,133.76c.26,3.76.38,15.74-1.38,24.26-1.65,8-7,22-7.7,25.68s-3.9,3.33-3.49-1,3.41-13.57,5.52-20.23a49.43,49.43,0,0,0,2.35-11l.5-18.2A4.71,4.71,0,0,0,422.38,133.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83,173.73s2.76-1.41,4.17,1.22l1.1-3.34S416.49,169,413,170Z",
    style: {
      fill: "#28A745"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.68,67.92c-.94,7.68-4.62,12.06-9.3,14.3l-4.48-2.59a11.43,11.43,0,0,0,2.2-5,15.29,15.29,0,0,0,.11-5.23l7-4C459.91,67.76,464.68,67.92,464.68,67.92Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.68,67.92c-.94,7.68-4.62,12.06-9.3,14.3l-4.48-2.59a11.43,11.43,0,0,0,2.2-5,15.29,15.29,0,0,0,.11-5.23l7-4C459.91,67.76,464.68,67.92,464.68,67.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.32,20.05V59.3a4.65,4.65,0,0,1-2.1,3.64l-8.54,5c-.94,7.68-4.62,12.06-9.3,14.3C458,79,458.08,74.3,457.69,72L453.1,74.6,447,78.11a4.64,4.64,0,0,1-4.2,0l-1.72-1A4.66,4.66,0,0,1,439,73.48V34.23a4.65,4.65,0,0,1,2.1-3.64l26.22-15.16a4.64,4.64,0,0,1,4.2,0l1.71,1A4.66,4.66,0,0,1,475.32,20.05Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,73.48a4.65,4.65,0,0,0,2.1,3.64l1.71,1a4.67,4.67,0,0,0,3.84.17c-1,.37-1.74-.18-1.74-1.38V37.64a4.32,4.32,0,0,1,.61-2.07l-5.91-3.41a4.29,4.29,0,0,0-.61,2.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.25,19.46c-.24-.9-1.05-1.18-2-.62L447,34a4.09,4.09,0,0,0-1.48,1.57l-5.91-3.41a4.16,4.16,0,0,1,1.48-1.57l26.22-15.17a4.64,4.64,0,0,1,4.2,0l1.72,1A4.6,4.6,0,0,1,475.25,19.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.83,39.24c0-6.09-4-8.71-9-5.86s-9,10.12-9,16.21V51c0,4.69,5.32,10.13,7.76,12.39a1.21,1.21,0,0,0,1.91-.36c2.11-4.32,8.26-17.34,8.26-22.38Zm-9,10c-2.62,1.52-4.75.29-4.75-2.74a10.52,10.52,0,0,1,4.75-8.24c2.63-1.52,4.76-.29,4.76,2.75A10.49,10.49,0,0,1,459.86,49.22Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAdmin);
export default __webpack_public_path__ + "static/media/LocationAdmin.7feb5c1f92fe2e622c03b8eaa586461a.svg";
export { ForwardRef as ReactComponent };